var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import require$$1, { useImperativeHandle, useEffect, createElement, Children, forwardRef, createContext, useContext, useRef, useState, useCallback, useMemo, useLayoutEffect, Fragment } from "react";
import { Flex, Label, Title, InputField, Slider, Box, Icon, IconSizes, Paragraph, Link, Span, useMatchMedia, Card, Button, Modal, Stack as Stack$1, StackItem, ThemeProvider, legacyMarketingUITheme, MatchMediaProvider, InlineCallout, Tooltip, Triggers, TextColors, ButtonVariant, useGuiForm, VStack, Input, InputTypes, TitleSizes, ParagraphSizes, buildResponsiveValues, Submit, Radio, HStack, Tag, TagVariant, useCollapsible, Collapsible, CollapsibleAction, Select, Form as Form$1, AppProviders } from "@guideline-app/guideline-ui";
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2["_" + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
      for (var key in from) {
        if (hasOwnProperty2.call(from, key)) {
          to[key] = from[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
    return to;
  };
  return objectAssign;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  requireObjectAssign();
  var f = require$$1, g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    reactJsxRuntime_production_min.Fragment = h("react.fragment");
  }
  var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for (b in a)
      n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
  }
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React = require$$1;
        var _assign = requireObjectAssign();
        var REACT_ELEMENT_TYPE2 = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports2.Fragment = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE2 = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          exports2.Fragment = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          symbolFor("react.scope");
          symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function error(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
        function printWarning(level, format, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack !== "") {
              format += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === exports2.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type) {
          return type.displayName || "Context";
        }
        function getComponentName(type) {
          if (type == null) {
            return null;
          }
          {
            if (typeof type.tag === "number") {
              error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type === "function") {
            return type.displayName || type.name || null;
          }
          if (typeof type === "string") {
            return type;
          }
          switch (type) {
            case exports2.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return getComponentName(init(payload));
                } catch (x) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign({}, props, {
                  value: prevLog
                }),
                info: _assign({}, props, {
                  value: prevInfo
                }),
                warn: _assign({}, props, {
                  value: prevWarn
                }),
                error: _assign({}, props, {
                  value: prevError
                }),
                group: _assign({}, props, {
                  value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix;
        function describeBuiltInComponentFrame(name, source, ownerFn) {
          {
            if (prefix === void 0) {
              try {
                throw Error();
              } catch (x) {
                var match = x.stack.trim().match(/\n( *(at )?)/);
                prefix = match && match[1] || "";
              }
            }
            return "\n" + prefix + name;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn, construct) {
          if (!fn || reentry) {
            return "";
          }
          {
            var frame = componentFrameCache.get(fn);
            if (frame !== void 0) {
              return frame;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x) {
                  control = x;
                }
                Reflect.construct(fn, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x) {
                  control = x;
                }
                fn.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x) {
                control = x;
              }
              fn();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s = sampleLines.length - 1;
              var c = controlLines.length - 1;
              while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
                c--;
              }
              for (; s >= 1 && c >= 0; s--, c--) {
                if (sampleLines[s] !== controlLines[c]) {
                  if (s !== 1 || c !== 1) {
                    do {
                      s--;
                      c--;
                      if (c < 0 || sampleLines[s] !== controlLines[c]) {
                        var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                        {
                          if (typeof fn === "function") {
                            componentFrameCache.set(fn, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s >= 1 && c >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name = fn ? fn.displayName || fn.name : "";
          var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
          {
            if (typeof fn === "function") {
              componentFrameCache.set(fn, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeFunctionComponentFrame(fn, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn, false);
          }
        }
        function shouldConstruct(Component) {
          var prototype = Component.prototype;
          return !!(prototype && prototype.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
          if (type == null) {
            return "";
          }
          if (typeof type === "function") {
            {
              return describeNativeComponentFrame(type, shouldConstruct(type));
            }
          }
          if (typeof type === "string") {
            return describeBuiltInComponentFrame(type);
          }
          switch (type) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {
                }
              }
            }
          }
          return "";
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        var didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config) {
          {
            if (hasOwnProperty2.call(config, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== void 0;
        }
        function hasValidKey(config) {
          {
            if (hasOwnProperty2.call(config, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== void 0;
        }
        function warnIfStringRefCannotBeAutoConverted(config, self2) {
          {
            if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        function defineKeyPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingKey = function() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props, "key", {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }
        function defineRefPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingRef = function() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props, "ref", {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        var ReactElement = function(type, key, ref, self2, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE2,
            // Built-in properties that belong on the element
            type,
            key,
            ref,
            props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function jsxDEV(type, config, maybeKey, source, self2) {
          {
            var propName;
            var props = {};
            var key = null;
            var ref = null;
            if (maybeKey !== void 0) {
              key = "" + maybeKey;
            }
            if (hasValidKey(config)) {
              key = "" + config.key;
            }
            if (hasValidRef(config)) {
              ref = config.ref;
              warnIfStringRefCannotBeAutoConverted(config, self2);
            }
            for (propName in config) {
              if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
            if (type && type.defaultProps) {
              var defaultProps = type.defaultProps;
              for (propName in defaultProps) {
                if (props[propName] === void 0) {
                  props[propName] = defaultProps[propName];
                }
              }
            }
            if (key || ref) {
              var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
            return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function isValidElement(object2) {
          {
            return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
          }
        }
        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name = getComponentName(ReactCurrentOwner$1.current.type);
              if (name) {
                return "\n\nCheck the render method of `" + name + "`.";
              }
            }
            return "";
          }
        }
        function getSourceInfoErrorAddendum(source) {
          {
            if (source !== void 0) {
              var fileName = source.fileName.replace(/^.*[\\\/]/, "");
              var lineNumber = source.lineNumber;
              return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
            }
            return "";
          }
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();
            if (!info) {
              var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }
            return info;
          }
        }
        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }
            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            var childOwner = "";
            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }
            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node, parentType) {
          {
            if (typeof node !== "object") {
              return;
            }
            if (Array.isArray(node)) {
              for (var i = 0; i < node.length; i++) {
                var child = node[i];
                if (isValidElement(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement(node)) {
              if (node._store) {
                node._store.validated = true;
              }
            } else if (node) {
              var iteratorFn = getIteratorFn(node);
              if (typeof iteratorFn === "function") {
                if (iteratorFn !== node.entries) {
                  var iterator = iteratorFn.call(node);
                  var step;
                  while (!(step = iterator.next()).done) {
                    if (isValidElement(step.value)) {
                      validateExplicitKey(step.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type = element.type;
            if (type === null || type === void 0 || typeof type === "string") {
              return;
            }
            var propTypes;
            if (typeof type === "function") {
              propTypes = type.propTypes;
            } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type.propTypes;
            } else {
              return;
            }
            if (propTypes) {
              var name = getComponentName(type);
              checkPropTypes(propTypes, element.props, "prop", name, element);
            } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type);
              error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
              error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys2 = Object.keys(fragment.props);
            for (var i = 0; i < keys2.length; i++) {
              var key = keys2[i];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
          {
            var validType = isValidElementType(type);
            if (!validType) {
              var info = "";
              if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
                info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
              }
              var sourceInfo = getSourceInfoErrorAddendum(source);
              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }
              var typeString;
              if (type === null) {
                typeString = "null";
              } else if (Array.isArray(type)) {
                typeString = "array";
              } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE2) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
              } else {
                typeString = typeof type;
              }
              error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
            var element = jsxDEV(type, props, key, source, self2);
            if (element == null) {
              return element;
            }
            if (validType) {
              var children = props.children;
              if (children !== void 0) {
                if (isStaticChildren) {
                  if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                      validateChildKeys(children[i], type);
                    }
                    if (Object.freeze) {
                      Object.freeze(children);
                    }
                  } else {
                    error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                  }
                } else {
                  validateChildKeys(children, type);
                }
              }
            }
            if (type === exports2.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }
            return element;
          }
        }
        function jsxWithValidationStatic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, true);
          }
        }
        function jsxWithValidationDynamic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, false);
          }
        }
        var jsx = jsxWithValidationDynamic;
        var jsxs = jsxWithValidationStatic;
        exports2.jsx = jsx;
        exports2.jsxs = jsxs;
      })();
    }
  })(reactJsxRuntime_development);
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
  }
  Object.keys(source).forEach(function(key) {
    if (!options.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    } else {
      destination[key] = deepmerge(target[key], source[key], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array2, options) {
  if (!Array.isArray(array2)) {
    throw new Error("first argument should be an array");
  }
  return array2.reduce(function(prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root = freeGlobal || freeSelf || Function("return this")();
var Symbol$1 = root.Symbol;
var objectProto$f = Object.prototype;
var hasOwnProperty$c = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : void 0;
function getRawTag(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : void 0;
function baseGetTag(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var getPrototype = overArg(Object.getPrototypeOf, Object);
function isObjectLike(value) {
  return value != null && typeof value == "object";
}
var objectTag$4 = "[object Object]";
var funcProto$2 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$2 = funcProto$2.toString;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
var objectCtorString = funcToString$2.call(Object);
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$4) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$b.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$2.call(Ctor) == objectCtorString;
}
var isArray$1 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== "undefined";
function equal(a, b) {
  if (a === b)
    return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    var arrA = isArray$1(a), arrB = isArray$1(b), i, length, key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (!equal(a[i], b[i]))
          return false;
      return true;
    }
    if (arrA != arrB)
      return false;
    var dateA = a instanceof Date, dateB = b instanceof Date;
    if (dateA != dateB)
      return false;
    if (dateA && dateB)
      return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
    if (regexpA != regexpB)
      return false;
    if (regexpA && regexpB)
      return a.toString() == b.toString();
    var keys2 = keyList(a);
    length = keys2.length;
    if (length !== keyList(b).length)
      return false;
    for (i = length; i-- !== 0; )
      if (!hasProp.call(b, keys2[i]))
        return false;
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;
    for (i = length; i-- !== 0; ) {
      key = keys2[i];
      if (key === "_owner" && a.$$typeof) {
        continue;
      } else {
        if (!equal(a[key], b[key]))
          return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
      console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
      return false;
    }
    throw error;
  }
};
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare);
var isProduction = process.env.NODE_ENV === "production";
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text = "Warning: " + message;
    if (typeof console !== "undefined") {
      console.warn(text);
    }
    try {
      throw Error(text);
    } catch (x) {
    }
  }
}
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
function assocIndexOf(array2, key) {
  var length = array2.length;
  while (length--) {
    if (eq(array2[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
function listCacheGet(key) {
  var data = this.__data__, index = assocIndexOf(data, key);
  return index < 0 ? void 0 : data[index][1];
}
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}
function listCacheSet(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
function ListCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}
function stackDelete(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet(key) {
  return this.__data__.get(key);
}
function stackHas(key) {
  return this.__data__.has(key);
}
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var asyncTag = "[object AsyncFunction]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$1(value) {
  if (!isObject$2(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var coreJsData = root["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$c = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$a).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative(value) {
  if (!isObject$2(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function getValue(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative(object2, key) {
  var value = getValue(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var Map$1 = getNative(root, "Map");
var nativeCreate = getNative(Object, "create");
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$9.call(data, key) ? data[key] : void 0;
}
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== void 0 : hasOwnProperty$8.call(data, key);
}
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
function Hash(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete(key) {
  var result = getMapData(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}
function mapCacheSet(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
var LARGE_ARRAY_SIZE = 200;
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
function arrayEach(array2, iteratee) {
  var index = -1, length = array2 == null ? 0 : array2.length;
  while (++index < length) {
    if (iteratee(array2[index], index, array2) === false) {
      break;
    }
  }
  return array2;
}
var defineProperty = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e) {
  }
}();
function baseAssignValue(object2, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
function assignValue(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$7.call(object2, key) && eq(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
function copyObject(source, props, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index = -1, length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object2, key, newValue);
    } else {
      assignValue(object2, key, newValue);
    }
  }
  return object2;
}
function baseTimes(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var argsTag$3 = "[object Arguments]";
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$3;
}
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;
var isArguments = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$6.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArray = Array.isArray;
function stubFalse() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$1 = moduleExports$2 ? root.Buffer : void 0;
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : void 0;
var isBuffer = nativeIsBuffer || stubFalse;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var argsTag$2 = "[object Arguments]", arrayTag$2 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", funcTag$1 = "[object Function]", mapTag$5 = "[object Map]", numberTag$3 = "[object Number]", objectTag$3 = "[object Object]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$4 = "[object String]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] = typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] = typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] = typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$5] = typedArrayTags[numberTag$3] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] = typedArrayTags[setTag$5] = typedArrayTags[stringTag$4] = typedArrayTags[weakMapTag$2] = false;
function baseIsTypedArray(value) {
  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal.process;
var nodeUtil = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e) {
  }
}();
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$6 = Object.prototype;
function isPrototype(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$6;
  return value === proto;
}
var nativeKeys = overArg(Object.keys, Object);
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function baseKeys(object2) {
  if (!isPrototype(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$4.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}
function keys(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2) : baseKeys(object2);
}
function baseAssign(object2, source) {
  return object2 && copyObject(source, keys(source), object2);
}
function nativeKeysIn(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function baseKeysIn(object2) {
  if (!isObject$2(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$3.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn(object2) {
  return isArrayLike(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
function baseAssignIn(object2, source) {
  return object2 && copyObject(source, keysIn(source), object2);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer2 = moduleExports ? root.Buffer : void 0, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
  buffer.copy(result);
  return result;
}
function copyArray(source, array2) {
  var index = -1, length = source.length;
  array2 || (array2 = Array(length));
  while (++index < length) {
    array2[index] = source[index];
  }
  return array2;
}
function arrayFilter(array2, predicate) {
  var index = -1, length = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array2[index];
    if (predicate(value, index, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray() {
  return [];
}
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols$1(object2), function(symbol) {
    return propertyIsEnumerable.call(object2, symbol);
  });
};
const getSymbols$1 = getSymbols;
function copySymbols(source, object2) {
  return copyObject(source, getSymbols$1(source), object2);
}
function arrayPush(array2, values) {
  var index = -1, length = values.length, offset = array2.length;
  while (++index < length) {
    array2[offset + index] = values[index];
  }
  return array2;
}
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object2) {
  var result = [];
  while (object2) {
    arrayPush(result, getSymbols$1(object2));
    object2 = getPrototype(object2);
  }
  return result;
};
function copySymbolsIn(source, object2) {
  return copyObject(source, getSymbolsIn(source), object2);
}
function baseGetAllKeys(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray(object2) ? result : arrayPush(result, symbolsFunc(object2));
}
function getAllKeys(object2) {
  return baseGetAllKeys(object2, keys, getSymbols$1);
}
function getAllKeysIn(object2) {
  return baseGetAllKeys(object2, keysIn, getSymbolsIn);
}
var DataView = getNative(root, "DataView");
var Promise$1 = getNative(root, "Promise");
var Set$1 = getNative(root, "Set");
var WeakMap$1 = getNative(root, "WeakMap");
var mapTag$4 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$4 = "[object Set]", weakMapTag$1 = "[object WeakMap]";
var dataViewTag$3 = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag = baseGetTag;
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag$3 || Map$1 && getTag(new Map$1()) != mapTag$4 || Promise$1 && getTag(Promise$1.resolve()) != promiseTag || Set$1 && getTag(new Set$1()) != setTag$4 || WeakMap$1 && getTag(new WeakMap$1()) != weakMapTag$1) {
  getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$3;
        case mapCtorString:
          return mapTag$4;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$4;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
const getTag$1 = getTag;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function initCloneArray(array2) {
  var length = array2.length, result = new array2.constructor(length);
  if (length && typeof array2[0] == "string" && hasOwnProperty$2.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
var Uint8Array2 = root.Uint8Array;
const Uint8Array$1 = Uint8Array2;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto$2 = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var boolTag$2 = "[object Boolean]", dateTag$2 = "[object Date]", mapTag$3 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$3 = "[object String]", symbolTag$3 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
function initCloneByTag(object2, tag, isDeep) {
  var Ctor = object2.constructor;
  switch (tag) {
    case arrayBufferTag$2:
      return cloneArrayBuffer(object2);
    case boolTag$2:
    case dateTag$2:
      return new Ctor(+object2);
    case dataViewTag$2:
      return cloneDataView(object2, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return cloneTypedArray(object2, isDeep);
    case mapTag$3:
      return new Ctor();
    case numberTag$2:
    case stringTag$3:
      return new Ctor(object2);
    case regexpTag$2:
      return cloneRegExp(object2);
    case setTag$3:
      return new Ctor();
    case symbolTag$3:
      return cloneSymbol(object2);
  }
}
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
  function object2() {
  }
  return function(proto) {
    if (!isObject$2(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object2.prototype = proto;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype(object2) ? baseCreate(getPrototype(object2)) : {};
}
var mapTag$2 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$2;
}
var nodeIsMap = nodeUtil && nodeUtil.isMap;
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
var setTag$2 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$2;
}
var nodeIsSet = nodeUtil && nodeUtil.isSet;
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG$1 = 4;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag$1 = "[object Map]", numberTag$1 = "[object Number]", objectTag$1 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$1 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$1] = cloneableTags[arrayTag$1] = cloneableTags[arrayBufferTag$1] = cloneableTags[dataViewTag$1] = cloneableTags[boolTag$1] = cloneableTags[dateTag$1] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag$1] = cloneableTags[numberTag$1] = cloneableTags[objectTag$1] = cloneableTags[regexpTag$1] = cloneableTags[setTag$1] = cloneableTags[stringTag$2] = cloneableTags[symbolTag$2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag$1] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
function baseClone(value, bitmask, customizer, key, object2, stack) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object2 ? customizer(value, key, object2, stack) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$2(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value), isFunc = tag == funcTag || tag == genTag;
    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag$1 || isFunc && !object2) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object2 ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
  var props = isArr ? void 0 : keysFunc(value);
  arrayEach(props || value, function(subValue, key2) {
    if (props) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
  });
  return result;
}
var CLONE_SYMBOLS_FLAG = 4;
function clone$1(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}
function arrayMap(array2, iteratee) {
  var index = -1, length = array2 == null ? 0 : array2.length, result = Array(length);
  while (++index < length) {
    result[index] = iteratee(array2[index], index, array2);
  }
  return result;
}
var symbolTag$1 = "[object Symbol]";
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag$1;
}
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });
  var cache = result.cache;
  return result;
}
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName, function(match, number2, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number2 || match);
  });
  return result;
});
const stringToPath$1 = stringToPath;
var INFINITY$1 = 1 / 0;
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var INFINITY = 1 / 0;
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray(value)) {
    return arrayMap(value, baseToString) + "";
  }
  if (isSymbol(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function toString$1(value) {
  return value == null ? "" : baseToString(value);
}
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString$1(value)));
}
var reactIs$1 = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
  function z(a) {
    if ("object" === typeof a && null !== a) {
      var u = a.$$typeof;
      switch (u) {
        case c:
          switch (a = a.type, a) {
            case l:
            case m:
            case e:
            case g:
            case f:
            case p:
              return a;
            default:
              switch (a = a && a.$$typeof, a) {
                case k:
                case n:
                case t:
                case r:
                case h:
                  return a;
                default:
                  return u;
              }
          }
        case d:
          return u;
      }
    }
  }
  function A(a) {
    return z(a) === m;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m;
  reactIs_production_min.ContextConsumer = k;
  reactIs_production_min.ContextProvider = h;
  reactIs_production_min.Element = c;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e;
  reactIs_production_min.Lazy = t;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d;
  reactIs_production_min.Profiler = g;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a) {
    return z(a) === k;
  };
  reactIs_production_min.isContextProvider = function(a) {
    return z(a) === h;
  };
  reactIs_production_min.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
  };
  reactIs_production_min.isForwardRef = function(a) {
    return z(a) === n;
  };
  reactIs_production_min.isFragment = function(a) {
    return z(a) === e;
  };
  reactIs_production_min.isLazy = function(a) {
    return z(a) === t;
  };
  reactIs_production_min.isMemo = function(a) {
    return z(a) === r;
  };
  reactIs_production_min.isPortal = function(a) {
    return z(a) === d;
  };
  reactIs_production_min.isProfiler = function(a) {
    return z(a) === g;
  };
  reactIs_production_min.isStrictMode = function(a) {
    return z(a) === f;
  };
  reactIs_production_min.isSuspense = function(a) {
    return z(a) === p;
  };
  reactIs_production_min.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
  };
  reactIs_production_min.typeOf = z;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE2 = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type = object2.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
if (process.env.NODE_ENV === "production") {
  reactIs$1.exports = requireReactIs_production_min();
} else {
  reactIs$1.exports = requireReactIs_development();
}
var reactIsExports = reactIs$1.exports;
var reactIs = reactIsExports;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var FormikContext = /* @__PURE__ */ createContext(void 0);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}
var isFunction = function isFunction2(obj) {
  return typeof obj === "function";
};
var isObject$1 = function isObject(obj) {
  return obj !== null && typeof obj === "object";
};
var isInteger = function isInteger2(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var isString$1 = function isString(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
};
var isEmptyChildren = function isEmptyChildren2(children) {
  return Children.count(children) === 0;
};
var isPromise = function isPromise2(value) {
  return isObject$1(value) && isFunction(value.then);
};
function getActiveElement(doc) {
  doc = doc || (typeof document !== "undefined" ? document : void 0);
  if (typeof doc === "undefined") {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
function getIn$1(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }
  var path = toPath(key);
  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }
  if (p !== path.length && !obj) {
    return def;
  }
  return obj === void 0 ? def : obj;
}
function setIn(obj, path, value) {
  var res = clone$1(obj);
  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn$1(obj, pathArray.slice(0, i + 1));
    if (currentObj && (isObject$1(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone$1(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }
  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }
  if (value === void 0) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  }
  if (i === 0 && value === void 0) {
    delete res[pathArray[i]];
  }
  return res;
}
function setNestedObjectValues(object2, value, visited, response) {
  if (visited === void 0) {
    visited = /* @__PURE__ */ new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(object2); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object2[k];
    if (isObject$1(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }
  return response;
}
function formikReducer(state, msg) {
  switch (msg.type) {
    case "SET_VALUES":
      return _extends({}, state, {
        values: msg.payload
      });
    case "SET_TOUCHED":
      return _extends({}, state, {
        touched: msg.payload
      });
    case "SET_ERRORS":
      if (isEqual$1(state.errors, msg.payload)) {
        return state;
      }
      return _extends({}, state, {
        errors: msg.payload
      });
    case "SET_STATUS":
      return _extends({}, state, {
        status: msg.payload
      });
    case "SET_ISSUBMITTING":
      return _extends({}, state, {
        isSubmitting: msg.payload
      });
    case "SET_ISVALIDATING":
      return _extends({}, state, {
        isValidating: msg.payload
      });
    case "SET_FIELD_VALUE":
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });
    case "SET_FIELD_ERROR":
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });
    case "RESET_FORM":
      return _extends({}, state, msg.payload);
    case "SET_FORMIK_STATE":
      return msg.payload(state);
    case "SUBMIT_ATTEMPT":
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return _extends({}, state, {
        isSubmitting: false
      });
    case "SUBMIT_SUCCESS":
      return _extends({}, state, {
        isSubmitting: false
      });
    default:
      return state;
  }
}
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);
  var props = _extends({
    validateOnChange,
    validateOnBlur,
    validateOnMount,
    onSubmit
  }, rest);
  var initialValues2 = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});
  if (process.env.NODE_ENV !== "production") {
    useEffect(function() {
      !(typeof isInitialValid === "undefined") ? process.env.NODE_ENV !== "production" ? warning(false, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : warning(false) : void 0;
    }, []);
  }
  useEffect(function() {
    isMounted.current = true;
    return function() {
      isMounted.current = false;
    };
  }, []);
  var _React$useState = useState(0), setIteration = _React$useState[1];
  var stateRef = useRef({
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  });
  var state = stateRef.current;
  var dispatch = useCallback(function(action) {
    var prev = stateRef.current;
    stateRef.current = formikReducer(prev, action);
    if (prev !== stateRef.current)
      setIteration(function(x) {
        return x + 1;
      });
  }, []);
  var runValidateHandler = useCallback(function(values, field) {
    return new Promise(function(resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);
      if (maybePromisedErrors == null) {
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function(errors) {
          resolve(errors || emptyErrors);
        }, function(actualException) {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }
          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  var runValidationSchema = useCallback(function(values, field) {
    var validationSchema2 = props.validationSchema;
    var schema = isFunction(validationSchema2) ? validationSchema2(field) : validationSchema2;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function(resolve, reject) {
      promise.then(function() {
        resolve(emptyErrors);
      }, function(err) {
        if (err.name === "ValidationError") {
          resolve(yupToFormErrors(err));
        } else {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }
          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function(field, value) {
    return new Promise(function(resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function(values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
      return isFunction(fieldRegistry.current[f].validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
      return runSingleFieldLevelValidation(f, getIn$1(values, f));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(fieldValidations).then(function(fieldErrorsList) {
      return fieldErrorsList.reduce(function(prev, curr, index) {
        if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") {
          return prev;
        }
        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }
        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]);
  var runAllValidations = useCallback(function(values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function(_ref2) {
      var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]);
  var validateFormWithHighPriority = useEventCallback(function(values) {
    if (values === void 0) {
      values = state.values;
    }
    dispatch({
      type: "SET_ISVALIDATING",
      payload: true
    });
    return runAllValidations(values).then(function(combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
        dispatch({
          type: "SET_ERRORS",
          payload: combinedErrors
        });
      }
      return combinedErrors;
    });
  });
  useEffect(function() {
    if (validateOnMount && isMounted.current === true && isEqual$1(initialValues2.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues2.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function(nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues2.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues2.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;
    var dispatchFn = function dispatchFn2() {
      dispatch({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors,
          touched,
          status,
          values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
        }
      });
    };
    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched, props.onReset]);
  useEffect(function() {
    if (isMounted.current === true && !isEqual$1(initialValues2.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues2.current = props.initialValues;
        resetForm();
        if (validateOnMount) {
          validateFormWithHighPriority(initialValues2.current);
        }
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$1(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: "SET_ERRORS",
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$1(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: "SET_TOUCHED",
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$1(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: "SET_STATUS",
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function(name) {
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn$1(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);
      if (isPromise(maybePromise)) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: true
        });
        return maybePromise.then(function(x) {
          return x;
        }).then(function(error) {
          dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: "SET_ISVALIDATING",
            payload: false
          });
        });
      } else {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: "SET_ISVALIDATING",
        payload: true
      });
      return runValidationSchema(state.values, name).then(function(x) {
        return x;
      }).then(function(error) {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name,
            value: getIn$1(error, name)
          }
        });
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
      });
    }
    return Promise.resolve();
  });
  var registerField = useCallback(function(name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate
    };
  }, []);
  var unregisterField = useCallback(function(name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function(touched, shouldValidate) {
    dispatch({
      type: "SET_TOUCHED",
      payload: touched
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function(errors) {
    dispatch({
      type: "SET_ERRORS",
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function(values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: "SET_VALUES",
      payload: resolvedValues
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function(field, value) {
    dispatch({
      type: "SET_FIELD_ERROR",
      payload: {
        field,
        value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
    dispatch({
      type: "SET_FIELD_VALUE",
      payload: {
        field,
        value
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function(eventOrTextValue, maybePath) {
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed;
    if (!isString$1(eventOrTextValue)) {
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }
      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;
      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
          handlerName: "handleChange"
        });
      }
      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type) ? getValueForCheckbox(getIn$1(state.values, field), checked, value) : options && multiple ? getSelectedValues(options) : value;
    }
    if (field) {
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function(eventOrPath) {
    if (isString$1(eventOrPath)) {
      return function(event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }
    dispatch({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field,
        value: touched
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function(e, path) {
    if (e.persist) {
      e.persist();
    }
    var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;
    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: "handleblur-e-any--void",
        handlerName: "handleBlur"
      });
    }
    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function(eventOrString) {
    if (isString$1(eventOrString)) {
      return function(event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function(stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function(status) {
    dispatch({
      type: "SET_STATUS",
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function(isSubmitting) {
    dispatch({
      type: "SET_ISSUBMITTING",
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function() {
    dispatch({
      type: "SUBMIT_ATTEMPT"
    });
    return validateFormWithHighPriority().then(function(combinedErrors) {
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
      if (isActuallyValid) {
        var promiseOrUndefined;
        try {
          promiseOrUndefined = executeSubmit();
          if (promiseOrUndefined === void 0) {
            return;
          }
        } catch (error) {
          throw error;
        }
        return Promise.resolve(promiseOrUndefined).then(function(result) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_SUCCESS"
            });
          }
          return result;
        })["catch"](function(_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_FAILURE"
            });
            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        dispatch({
          type: "SUBMIT_FAILURE"
        });
        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }
      return;
    });
  });
  var handleSubmit = useEventCallback(function(e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }
    if (process.env.NODE_ENV !== "production" && typeof document !== "undefined") {
      var activeElement = getActiveElement();
      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem("type")) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }
    submitForm()["catch"](function(reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm,
    validateForm: validateFormWithHighPriority,
    validateField,
    setErrors,
    setFieldError,
    setFieldTouched,
    setFieldValue,
    setStatus,
    setSubmitting,
    setTouched,
    setValues,
    setFormikState,
    submitForm
  };
  var executeSubmit = useEventCallback(function() {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function(e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }
    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }
    resetForm();
  });
  var getFieldMeta = useCallback(function(name) {
    return {
      value: getIn$1(state.values, name),
      error: getIn$1(state.errors, name),
      touched: !!getIn$1(state.touched, name),
      initialValue: getIn$1(initialValues2.current, name),
      initialTouched: !!getIn$1(initialTouched.current, name),
      initialError: getIn$1(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function(name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched2(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function(nameOrOptions) {
    var isAnObject = isObject$1(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn$1(state.values, name);
    var field = {
      name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };
    if (isAnObject) {
      var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
      if (type === "checkbox") {
        if (valueProp === void 0) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === "radio") {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === "select" && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }
    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function() {
    return !isEqual$1(initialValues2.current, state.values);
  }, [initialValues2.current, state.values]);
  var isValid = useMemo(function() {
    return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);
  var ctx = _extends({}, state, {
    initialValues: initialValues2.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur,
    handleChange,
    handleReset,
    handleSubmit,
    resetForm,
    setErrors,
    setFormikState,
    setFieldTouched,
    setFieldValue,
    setFieldError,
    setStatus,
    setSubmitting,
    setTouched,
    setValues,
    submitForm,
    validateForm: validateFormWithHighPriority,
    validateField,
    isValid,
    dirty,
    unregisterField,
    registerField,
    getFieldProps,
    getFieldMeta,
    getFieldHelpers,
    validateOnBlur,
    validateOnChange,
    validateOnMount
  });
  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef;
  useImperativeHandle(innerRef, function() {
    return formikbag;
  });
  if (process.env.NODE_ENV !== "production") {
    useEffect(function() {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0;
    }, []);
  }
  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? Children.only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
  var errors = {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }
    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
      var _ref5;
      if (_isArray) {
        if (_i >= _iterator.length)
          break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done)
          break;
        _ref5 = _i.value;
      }
      var err = _ref5;
      if (!getIn$1(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }
  return errors;
}
function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }
  var normalizedValues = prepareDataForValidation(values);
  return schema[sync ? "validateSync" : "validate"](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};
  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);
      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function(value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== "" ? value : void 0;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== "" ? values[key] : void 0;
      }
    }
  }
  return data;
}
function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === "undefined") {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
function getSelectedValues(options) {
  return Array.from(options).filter(function(el) {
    return el.selected;
  }).map(function(el) {
    return el.value;
  });
}
function getValueForCheckbox(currentValue, checked, valueProp) {
  if (typeof currentValue === "boolean") {
    return Boolean(checked);
  }
  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;
  if (!Array.isArray(currentValue)) {
    if (!valueProp || valueProp == "true" || valueProp == "false") {
      return Boolean(checked);
    }
  } else {
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  }
  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  }
  if (!isValueInArray) {
    return currentArrayOfValues;
  }
  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
function useEventCallback(fn) {
  var ref = useRef(fn);
  useIsomorphicLayoutEffect(function() {
    ref.current = fn;
  });
  return useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current.apply(void 0, args);
  }, []);
}
var Form = /* @__PURE__ */ forwardRef(function(props, ref) {
  var action = props.action, rest = _objectWithoutPropertiesLoose(props, ["action"]);
  var _action = action != null ? action : "#";
  var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
  return createElement("form", _extends({
    onSubmit: handleSubmit,
    ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = "Form";
const FIELDS = {
  input: {
    current_age: {
      label: "Current age",
      min: 18,
      max: 99,
      ageLimit: 55,
      defaultValue: "",
      error: {
        min: "Must be 18 - 99",
        max: "Must be 18 - 99",
        integer: "Must use numeric characters",
        required: "Required",
        typeError: "Must use numeric characters"
      }
    },
    retirement_age: {
      label: "Retirement age",
      min: 18,
      max: 100,
      defaultValue: "",
      error: {
        current_age: "Must be [LIMIT] - 100",
        max: "Maximum exceeded",
        integer: "Must use numeric characters",
        required: "Required",
        typeError: "Must use numeric characters"
      }
    },
    annual_income: {
      label: "Annual income",
      min: 0,
      max: 1e9,
      // 1 000 000 000 limit to avoid enter huge integer
      defaultValue: "",
      error: {
        min: "Invalid",
        max: "Maximum exceeded",
        integer: "Must use numeric characters",
        required: "Required",
        typeError: "Must use numeric characters"
      }
    }
  },
  slider: {
    monthly_contribution: {
      label: "Monthly contribution",
      min: 0,
      max: 1700,
      max_alternative: 2250,
      defaultValue: 250,
      error: {
        min: "Invalid",
        current_age: "Must be 0 - [LIMIT]",
        integer: "Must use numeric characters",
        required: "Required",
        typeError: "Must use numeric characters"
      }
    },
    investment_return: {
      label: "Investment return",
      min: 0,
      max: 12,
      defaultValue: 10,
      error: {
        min: "Must be 0% - 12%",
        max: "Must be 0% - 12%",
        integer: "Must use numeric characters",
        required: "Required",
        typeError: "Must use numeric characters"
      }
    }
  }
};
const FIELD_NAMES = [
  "current_age",
  "retirement_age",
  "annual_income",
  "monthly_contribution",
  "investment_return"
];
const ASSUMPTIONS_DISCLOSURES = {
  modalTitle: "Assumptions and disclosures",
  linkLabel: "Assumptions & disclosures",
  urlContent3: "https://www.irs.gov/retirement-plans/plan-participant-employee/retirement-topics-401k-and-profit-sharing-plan-contribution-limits",
  urlContent5: "https://www.irs.gov/retirement-plans/plan-participant-employee/amount-of-roth-ira-contributions-that-you-can-make-for-2022",
  urlContent8: "https://www.calsavers.com/",
  urlContent10: "https://www.calsavers.com/",
  content1: "This chart is a hypothetical comparison. The information provided herein is general in nature and is for informational purposes only. It should not be used as a substitute for specific tax, legal and/or financial advice that considers all relevant facts and circumstances. You are advised to consult a qualified financial adviser or tax professional before relying on the information provided herein. Investing involves risk of loss and performance and savings are not guaranteed.",
  content2: "IRS limits are subject to an annual cost-of-living adjustment. To learn more about annual IRS limits for 401(k) plans, visit the IRS website ",
  content3: "here",
  content4: ". To learn more about annual IRS limits for Roth IRAs, visit the IRS website ",
  content5: "here",
  content6: ".",
  content7: " Deadlines, fees, and other program details are subject to change by the state without notice and should be checked prior to making any decisions. If you already offer a qualified employer-sponsored plan, exemptions should be requested on the ",
  content8: "CalSaver's site",
  content9: ". Visit the ",
  content10: "CalSaver's site",
  content11: " to learn more."
};
const ASSUMPTIONS_DISCLOSURES_MODAL = {
  sections: [
    {
      content: "This illustration is a hypothetical comparison and for informational purposes only. It is intended to illustrate what an active employee in a Guideline 401(k) plan vs a CalSavers Roth IRA may be able to save for retirement. It does not take into account every specific circumstance that may be unique to your situation. It is not intended to provide tax, investment, or legal advice. Investing involves risk of loss and performance and savings are not guaranteed. There are inherent differences between a 401(k) and a Roth IRA and you should consult your own tax, investment, or legal advisor to determine a strategy that fits your specific needs. The analyses and calculations are based on certain assumptions described below. The analyses and calculations are also based on Guideline’s interpretation of prevailing law, which is subject to change at any time. No warranty or representation, express or implied, is made by Guideline, Inc., nor does Guideline Inc. accept any liability with respect to the analyses, calculations, and data set forth herein."
    },
    {
      title: "For the purpose of this calculator we assume",
      listItems: [
        "Current age: as inputted by you",
        "Retirement age: as inputted by you",
        "Annual income: as inputted by you",
        "Monthly contribution: as inputted by you. Due to 2022 401(k) contribution limits set by the IRS: 1) if you are under age 50, the calculator will cap you at a maximum monthly contribution of $1,700; and 2) if you are over age 50, the calculator will cap you at a maximum monthly contribution of $2,250.",
        "Investment return: your expected annual return as inputted by you. The calculator limits you to choose a range from 0%-12%."
      ]
    },
    {
      title: "Calculation and limitations",
      content: "As illustrated below, the calculator will factor in the following:",
      listItems: [
        "Retirement age must be higher than your current age",
        "Roth IRA contribution limits will be factored in when you choose a monthly contribution over $500",
        "Investment return: compounds monthly.",
        "Years until retirement is your retirement age minus your current age.",
        "Total months are the total number of months until retirement.",
        "Guideline fees: 0.0042 which assumes 0.34% (highest fund fee: TRPSX) 0.08% (annual account fee). [1]",
        {
          textA: "The calculation only considers fees for active Guideline employees and does not consider Guideline employer fees or fees that dismissed employees may pay. Learn more about our fees and services ",
          linkTo: "https://my.guideline.com/agreements/fees",
          textB: "here",
          textC: "."
        },
        {
          textA: "CalSavers fees: 0.0095 which assumes 0.05% (Program Administrator Fee - State) + 0.75% (Program Administrator Fee - Administrator) + 0.15% (highest fund fee). Learn more about CalSavers fees ",
          linkTo: "https://my.guideline.com/agreements/fees",
          textB: "here",
          textC: ". [2]"
        },
        {
          parentItem: "2022 IRS contribution limits:",
          subItems: [
            {
              textA: "Roth IRA:",
              textB: "AGI limits",
              linkTo: "https://www.irs.gov/retirement-plans/plan-participant-employee/amount-of-roth-ira-contributions-that-you-can-make-for-2022"
            },
            {
              textA: "Roth IRA:",
              textB: "contribution limits",
              linkTo: "https://www.irs.gov/retirement-plans/plan-participant-employee/amount-of-roth-ira-contributions-that-you-can-make-for-2022"
            },
            {
              textA: "401(k):",
              textB: "contribution limits",
              linkTo: "https://www.irs.gov/retirement-plans/plan-participant-employee/retirement-topics-401k-and-profit-sharing-plan-contribution-limits"
            }
          ]
        },
        "Tax filing status is Single",
        "Salary, deferral amount, and fees stay constant over the estimated time to retirement."
      ]
    },
    {
      title: "Equation",
      content: "Monthly contribution x ((( 1 + ((Annual return - fees) / Compound freq)^Years to retirement x Compound frequency) - 1)) / ((Annual return - fees) / Compound freq)"
    }
  ],
  guidelineFeesFooter: {
    textA: "[1] ",
    link1: "https://www.guideline.com/funds ",
    textB: "and ",
    link2: "https://my.guideline.com/agreements/fees ",
    textC: "The annual account fee of 0.08% applied to assets under management is calculated and deducted on a monthly basis at 1/12 of the annual stated rate (0.08%) based on the account balance on the last day of each month."
  },
  calSaversFeesFooter: {
    textA: "[2] ",
    link1: "https://saver.calsavers.com/home/savers/program-details.html ",
    textB: "Fees are subject to change by the state without notice and should be checked prior to making any decision."
  }
};
const BIG_DIFFERENCE = {
  title: "Why such a big difference?",
  content: {
    defaultContent: "Investment fees really add up over time. Guideline accounts have low-cost investments. This can add up to more money for retirement.",
    exceedIncomeLimit: "There are no income limits for a 401(k), so you can contribute regardless of income.",
    contributionLimit: "The annual contribution limit is about 3x that of a CalSavers IRA. Those additional savings can add up to a much larger nest egg in retirement."
  }
};
const CALC_RESULTS_DEFAULT = {
  defaultContent: "Enter details to see your savings potential",
  errorContent: "Correct form errors to proceed"
};
const ESTIMATED_TOTAL_SAVINGS = {
  noResultsPlaceholder: "-",
  title401k: "Guideline 401(k)",
  titleIRA: "CalSavers Roth IRA",
  subtitle: "Estimated total savings"
};
const HAVE_FIVE_PLUS_EMPLOYEES = {
  title: "Have 5+ employees?",
  content: "Sign up today to beat the June 30 deadline",
  buttonLabel: "Get started",
  getStartedUrl: "https://www.guideline.com/pipeline/basic"
};
const SAVING_MORE = {
  content1: "You could save ",
  content2: " more for retirement with a Guideline 401(k)"
};
const FORM = {
  warnAnnualIncome: "You exceed the income limits for a Roth IRA, and are unable to contribute to CalSavers.",
  warnReducedMonthlyContribution: "You are nearing the income limits for a Roth IRA, and can only contribute a reduced amount to CalSavers.",
  warnMonthlyContribution: "The maximum amount you can contribute in 2022 to a CalSavers IRA is $6,000 annually. The annual contribution limit for a Guideline 401(k) is much higher, at $20,500 annually."
};
const MAX_YEARLY_IRA_CONTRIBUTION_AMOUNT = 6e3;
const MAX_MONTHLY_IRA_CONTRIBUTION_AMOUNT = MAX_YEARLY_IRA_CONTRIBUTION_AMOUNT / 12;
const MAX_YEARLY_401K_CONTRIBUTION_AMOUNT = 20500;
const REDUCED_CONTRIBUTION_START_INCOME_AMOUNT = 129e3;
const MAX_YEARLY_IRA_INCOME_AMOUNT = 144e3;
const MAX_INCOME_ABOVE_LIMIT_ELIGIBLE = MAX_YEARLY_IRA_INCOME_AMOUNT - REDUCED_CONTRIBUTION_START_INCOME_AMOUNT;
const COMPOUND_FREQUENCY = 12;
const WARNING_MISSING_INPUT_DATA = "missingInputData";
const WARNING_MAX_IRA_CONTRIBUTION_EXCEEDED = "maxIraContributionExceeded";
const WARNING_MAX_401k_CONTRIBUTION_EXCEEDED = "max401kContributionExceeded";
const WARNING_MAX_INCOME_EXCEEDED = "maxIncomeExceeded";
const WARNING_REDUCED_CONTRIBUTION_AMOUNT = "reducedMonthlyContributionAmount";
const GUIDELINE_FEE = 42e-4;
const CALSAVERS_FEE = 95e-4;
const REQUIRED_INPUTS = [
  "currentAge",
  "retirementAge",
  "monthlyContribution",
  "investmentReturn",
  "yearlyIncome"
];
class Calculator {
  constructor() {
    __publicField(this, "_stringToInt", (val) => typeof val === "string" ? parseInt(val, 10) : val);
    this.warnings = {};
  }
  calculate(data) {
    this.warnings = {};
    this._validateInputs(data);
    this._normalizeDataTypes(data);
    const calSaversMonthlyContribution = this._calculateCalSaversMonthlyContribution(data);
    const calSaversTotalSavings = this._calculateTotalSavings(
      data,
      calSaversMonthlyContribution,
      CALSAVERS_FEE
    );
    const guidelineMonthlyContribution = this._calculateGuidelineMonthlyContribution(data);
    const guidelineTotalSavings = this._calculateTotalSavings(
      data,
      guidelineMonthlyContribution,
      GUIDELINE_FEE
    );
    return {
      calSaversTotalSavings,
      guidelineTotalSavings,
      warnings: this.warnings
    };
  }
  _calculateTotalSavings(data, totalMonthlyContribution, fee) {
    const { currentAge, retirementAge, investmentReturn } = data;
    const yearsToRetirement = retirementAge - currentAge;
    const totalMonthsToRetirement = COMPOUND_FREQUENCY * yearsToRetirement;
    const monthlyReturnRate = (investmentReturn - fee) / COMPOUND_FREQUENCY;
    const result = totalMonthlyContribution * (Math.pow(monthlyReturnRate + 1, totalMonthsToRetirement) - 1) / monthlyReturnRate;
    return Math.round(result);
  }
  _calculateGuidelineMonthlyContribution(data) {
    const { monthlyContribution } = data;
    if (monthlyContribution > MAX_YEARLY_401K_CONTRIBUTION_AMOUNT / COMPOUND_FREQUENCY) {
      this.warnings[WARNING_MAX_401k_CONTRIBUTION_EXCEEDED] = monthlyContribution;
      return MAX_YEARLY_401K_CONTRIBUTION_AMOUNT / COMPOUND_FREQUENCY;
    }
    return monthlyContribution;
  }
  _calculateCalSaversMonthlyContribution(data) {
    const { monthlyContribution, yearlyIncome } = data;
    let response;
    if (yearlyIncome > MAX_YEARLY_IRA_INCOME_AMOUNT) {
      this.warnings[WARNING_MAX_INCOME_EXCEEDED] = data.yearlyIncome;
      response = 0;
    }
    if (yearlyIncome >= REDUCED_CONTRIBUTION_START_INCOME_AMOUNT && yearlyIncome <= MAX_YEARLY_IRA_INCOME_AMOUNT) {
      const yearlyIncomeAboveLimit = yearlyIncome - REDUCED_CONTRIBUTION_START_INCOME_AMOUNT;
      const contributionReduction = yearlyIncomeAboveLimit / MAX_INCOME_ABOVE_LIMIT_ELIGIBLE * MAX_YEARLY_IRA_CONTRIBUTION_AMOUNT;
      const monthlyReducedAmount = (MAX_YEARLY_IRA_CONTRIBUTION_AMOUNT - contributionReduction) / COMPOUND_FREQUENCY;
      if (monthlyContribution > monthlyReducedAmount) {
        this.warnings[WARNING_REDUCED_CONTRIBUTION_AMOUNT] = monthlyReducedAmount;
        this.warnings[WARNING_MAX_IRA_CONTRIBUTION_EXCEEDED] = monthlyContribution;
        return response === void 0 ? monthlyReducedAmount : response;
      }
      return response === void 0 ? monthlyContribution : response;
    }
    if (monthlyContribution > MAX_MONTHLY_IRA_CONTRIBUTION_AMOUNT) {
      this.warnings[WARNING_MAX_IRA_CONTRIBUTION_EXCEEDED] = monthlyContribution;
      return response === void 0 ? MAX_MONTHLY_IRA_CONTRIBUTION_AMOUNT : response;
    }
    return response === void 0 ? monthlyContribution : response;
  }
  _validateInputs(data) {
    const invalidKeys = REQUIRED_INPUTS.filter((key) => !data[key]);
    if (invalidKeys.length) {
      this.warnings[WARNING_MISSING_INPUT_DATA] = invalidKeys;
    }
  }
  _normalizeDataTypes(data) {
    data.currentAge = this._stringToInt(data.currentAge);
    data.retirementAge = this._stringToInt(data.retirementAge);
    data.monthlyContribution = this._stringToInt(data.monthlyContribution);
    data.investmentReturn = typeof data.investmentReturn === "string" ? parseFloat(data.investmentReturn) : data.investmentReturn;
    data.yearlyIncome = this._stringToInt(data.yearlyIncome);
    return data;
  }
}
function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0;
  this._values = /* @__PURE__ */ Object.create(null);
};
Cache.prototype.get = function(key) {
  return this._values[key];
};
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values))
    this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(path) {
    var parts = normalizePath(path);
    return setCache.get(path) || setCache.set(path, function setter(obj, value) {
      var index = 0;
      var len = parts.length;
      var data = obj;
      while (index < len - 1) {
        var part = parts[index];
        if (part === "__proto__" || part === "constructor" || part === "prototype") {
          return obj;
        }
        data = data[parts[index++]];
      }
      data[parts[index]] = value;
    });
  },
  getter: function(path, safe) {
    var parts = normalizePath(path);
    return getCache.get(path) || getCache.set(path, function getter(data) {
      var index = 0, len = parts.length;
      while (index < len) {
        if (data != null || !safe)
          data = data[parts[index++]];
        else
          return;
      }
      return data;
    });
  },
  join: function(segments) {
    return segments.reduce(function(path, part) {
      return path + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path ? "." : "") + part);
    }, "");
  },
  forEach: function(path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  }
};
function normalizePath(path) {
  return pathCache.get(path) || pathCache.set(
    path,
    split(path).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, "$2");
    })
  );
}
function split(path) {
  return path.match(SPLIT_REGEX) || [""];
}
function forEach(parts, iter, thisArg) {
  var len = parts.length, part, idx, isArray2, isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray2 = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray2, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === "string" && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const words = (str) => str.match(reWords) || [];
const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);
const join = (str, d) => words(str).join(d).toLowerCase();
const camelCase = (str) => words(str).reduce(
  (acc, next) => `${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`,
  ""
);
const pascalCase = (str) => upperFirst(camelCase(str));
const snakeCase = (str) => join(str, "_");
const kebabCase = (str) => join(str, "-");
const sentenceCase = (str) => upperFirst(join(str, " "));
const titleCase = (str) => words(str).map(upperFirst).join(" ");
var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase
};
var toposort$2 = { exports: {} };
toposort$2.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }
  });
  while (i--) {
    if (!visited[i])
      visit(nodes[i], i, /* @__PURE__ */ new Set());
  }
  return sorted;
  function visit(node, i2, predecessors) {
    if (predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch (e) {
        nodeRep = "";
      }
      throw new Error("Cyclic dependency" + nodeRep);
    }
    if (!nodesHash.has(node)) {
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node));
    }
    if (visited[i2])
      return;
    visited[i2] = true;
    var outgoing = outgoingEdges.get(node) || /* @__PURE__ */ new Set();
    outgoing = Array.from(outgoing);
    if (i2 = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i2];
        visit(child, nodesHash.get(child), predecessors);
      } while (i2);
      predecessors.delete(node);
    }
    sorted[--cursor] = node;
  }
}
function uniqueNodes(arr) {
  var res = /* @__PURE__ */ new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = /* @__PURE__ */ new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0]))
      edges.set(edge[0], /* @__PURE__ */ new Set());
    if (!edges.has(edge[1]))
      edges.set(edge[1], /* @__PURE__ */ new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = /* @__PURE__ */ new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res;
}
var toposortExports = toposort$2.exports;
const toposort$1 = /* @__PURE__ */ getDefaultExportFromCjs(toposortExports);
const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : () => "";
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val)
    return "NaN";
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false)
    return "" + val;
  const typeOf = typeof val;
  if (typeOf === "number")
    return printNumber(val);
  if (typeOf === "string")
    return quoteStrings ? `"${val}"` : val;
  if (typeOf === "function")
    return "[Function " + (val.name || "anonymous") + "]";
  if (typeOf === "symbol")
    return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
  const tag = toString.call(val).slice(8, -1);
  if (tag === "Date")
    return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
  if (tag === "Error" || val instanceof Error)
    return "[" + errorToString.call(val) + "]";
  if (tag === "RegExp")
    return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null)
    return result;
  return JSON.stringify(value, function(key, value2) {
    let result2 = printSimpleValue(this[key], quoteStrings);
    if (result2 !== null)
      return result2;
    return value2;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = "Error";
    this.name = "ValidationError";
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach((err) => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || "this";
    if (path !== params.path)
      params = Object.assign({}, params, {
        path
      });
    if (typeof message === "string")
      return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === "function")
      return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === "ValidationError";
  }
  constructor(errorOrErrors, value, field, type, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = "Error";
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : ".";
    return type !== "mixed" ? `${path} must be a \`${type}\` type, but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
};
let number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
};
let date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
};
let boolean = {
  isValue: "${path} field must be ${value}"
};
let object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
let tuple = {
  notType: (params) => {
    const {
      path,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen)
        return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen)
        return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = (obj) => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === "function" ? is : (...values) => values.every((value) => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map((ref) => (
      // TODO: ? operator here?
      ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context)
    ));
    let schema = this.fn(values, base, options);
    if (schema === void 0 || // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema))
      throw new TypeError("conditions must return a schema object");
    return schema.resolve(options);
  }
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== "string")
      throw new TypeError("ref must be a string, got: " + key);
    this.key = key.trim();
    if (key === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter)
      result = this.getter(result || {});
    if (this.map)
      result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}
Reference.prototype.__isYupRef = true;
const isAbsent = (value) => value == null;
function createValidation(config) {
  function validate({
    value,
    path = "",
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams))
        nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = (validOrError) => {
      if (ValidationError.isError(validOrError))
        invalid(validOrError);
      else if (!validOrError)
        invalid(createError());
      else
        next(null);
    };
    const handleError = (err) => {
      if (ValidationError.isError(err))
        invalid(err);
      else
        panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test.call(ctx, value, ctx);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
        if (options.sync) {
          throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}
function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;
  if (!path)
    return {
      parent,
      parentPath: path,
      schema
    };
  propertyExpr.forEach(path, (_part, isBracket, isArray2) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === "tuple";
    let idx = isArray2 ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray2)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }
    if (!isArray2) {
      if (!schema.fields || !schema.fields[part])
        throw new Error(`The schema does not contain the path: ${path}. (failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach((value) => next.add(value));
    removeItems.forEach((value) => next.delete(value));
    return next;
  }
}
function clone(src, seen = /* @__PURE__ */ new Map()) {
  if (isSchema(src) || !src || typeof src !== "object")
    return src;
  if (seen.has(src))
    return seen.get(src);
  let copy;
  if (src instanceof Date) {
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++)
      copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    copy = /* @__PURE__ */ new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries())
      copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    copy = /* @__PURE__ */ new Set();
    seen.set(src, copy);
    for (const v of src)
      copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src))
      copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}
class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = /* @__PURE__ */ Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation((s) => {
      s.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec)
        Object.assign(this.spec, spec);
      return this;
    }
    const next = Object.create(Object.getPrototypeOf(this));
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0)
      return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this)
      return this;
    if (schema.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;
    combined.withMutation((next) => {
      schema.tests.forEach((fn) => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null)
        return true;
      if (this.spec.optional && v === void 0)
        return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === "ignore-optionality";
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || "field"} could not be cast to a value that satisfies the schema type: "${resolvedSchema.type}". 

attempted value: ${formattedValue} 
` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
    }
    return result;
  }
  _cast(rawValue, options) {
    let value = rawValue === void 0 ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === void 0) {
      value = this.getDefault(options);
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test)
        initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, (initialErrors) => {
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count)
      return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError("Must include `key` or `index` for nested validations");
    }
    const isIndex2 = typeof k === "number";
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [isIndex2 ? "index" : "key"]: k,
      path: isIndex2 || k.includes(".") ? `${parentPath || ""}[${isIndex2 ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : "") + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error))
        error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length)
        reject(new ValidationError(errors, validated, void 0, void 0, disableStackTrace));
      else
        resolve(validated);
    }));
  }
  validateSync(value, options) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error))
        error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length)
        throw new ValidationError(errors, value, void 0, void 0, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, (err) => {
      if (ValidationError.isError(err))
        return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err))
        return false;
      throw err;
    }
  }
  _getDefault(options) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === "function" ? defaultValue.call(this, options) : clone(defaultValue);
  }
  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault(options);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: "nullable",
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: "optionality",
      test(value) {
        return value === void 0 ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation((next) => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation((next) => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === "function") {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === void 0)
      opts.message = mixed.default;
    if (typeof opts.test !== "function")
      throw new TypeError("`test` is a required parameters");
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name)
        throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    }
    if (opts.name)
      next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter((fn) => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive)
          return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test)
          return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys2, options) {
    if (!Array.isArray(keys2) && typeof keys2 !== "string") {
      options = keys2;
      keys2 = ".";
    }
    let next = this.clone();
    let deps = toArray(keys2).map((key) => new Reference(key));
    deps.forEach((dep) => {
      if (dep.isSibling)
        next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === "function" ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: "typeError",
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value))
          return this.createError({
            params: {
              type: this.schema.type
            }
          });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: "oneOf",
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(", "),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach((val) => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: "notOneOf",
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value))
          return this.createError({
            params: {
              values: Array.from(invalids).join(", "),
              resolved
            }
          });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map((fn) => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex((c) => c.name === n.name) === idx)
    };
    return description;
  }
}
Schema.prototype.__isYupSchema__ = true;
for (const method of ["validate", "validateSync"])
  Schema.prototype[`${method}At`] = function(path, value, options = {}) {
    const {
      parent,
      parentPath,
      schema
    } = getIn(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
      parent,
      path
    }));
  };
for (const alias of ["equals", "is"])
  Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ["not", "nope"])
  Schema.prototype[alias] = Schema.prototype.notOneOf;
function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: "boolean",
      check(v) {
        if (v instanceof Boolean)
          v = v.valueOf();
        return typeof v === "boolean";
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (ctx.spec.coerce && !ctx.isType(value)) {
          if (/^(true|1)$/i.test(String(value)))
            return true;
          if (/^(false|0)$/i.test(String(value)))
            return false;
        }
        return value;
      });
    });
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "true"
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: "is-value",
      exclusive: true,
      params: {
        value: "false"
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
  default(def) {
    return super.default(def);
  }
  defined(msg) {
    return super.defined(msg);
  }
  optional() {
    return super.optional();
  }
  required(msg) {
    return super.required(msg);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(msg) {
    return super.nonNullable(msg);
  }
  strip(v) {
    return super.strip(v);
  }
}
create$7.prototype = BooleanSchema.prototype;
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date2) {
  const struct = parseDateStruct(date2);
  if (!struct)
    return Date.parse ? Date.parse(date2) : Number.NaN;
  if (struct.z === void 0 && struct.plusMinus === void 0) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== "Z" && struct.plusMinus !== void 0) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === "+")
      totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date2) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date2);
  if (!regexResult)
    return null;
  return {
    year: toNumber$1(regexResult[1]),
    month: toNumber$1(regexResult[2], 1) - 1,
    day: toNumber$1(regexResult[3], 1),
    hour: toNumber$1(regexResult[4]),
    minute: toNumber$1(regexResult[5]),
    second: toNumber$1(regexResult[6]),
    millisecond: regexResult[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      toNumber$1(regexResult[7].substring(0, 3))
    ) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : void 0,
    z: regexResult[8] || void 0,
    plusMinus: regexResult[9] || void 0,
    hourOffset: toNumber$1(regexResult[10]),
    minuteOffset: toNumber$1(regexResult[11])
  };
}
function toNumber$1(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}
let rEmail = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
);
let rUrl = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
);
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
let isTrimmed = (value) => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: "string",
      check(value) {
        if (value instanceof String)
          value = value.valueOf();
        return typeof value === "string";
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value))
          return value;
        if (Array.isArray(value))
          return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag)
          return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation((schema) => schema.test({
      message: message || mixed.required,
      name: "required",
      skipAbsent: true,
      test: (value) => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((schema) => {
      schema.tests = schema.tests.filter((t) => t.OPTIONS.name !== "required");
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: "max",
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === "object") {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || "matches",
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: (value) => value === "" && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message,
      excludeEmptyString: false
    });
  }
  datetime(options) {
    let message = "";
    let allowOffset;
    let precision;
    if (options) {
      if (typeof options === "object") {
        ({
          message = "",
          allowOffset = false,
          precision = void 0
        } = options);
      } else {
        message = options;
      }
    }
    return this.matches(rIsoDateTime, {
      name: "datetime",
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: "datetime_offset",
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: (value) => {
        if (!value || allowOffset)
          return true;
        const struct = parseDateStruct(value);
        if (!struct)
          return false;
        return !!struct.z;
      }
    }).test({
      name: "datetime_precision",
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: (value) => {
        if (!value || precision == void 0)
          return true;
        const struct = parseDateStruct(value);
        if (!struct)
          return false;
        return struct.precision === precision;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((val) => val === null ? "" : val);
  }
  trim(message = string.trim) {
    return this.transform((val) => val != null ? val.trim() : val).test({
      message,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform((value) => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform((value) => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;
let isNaN$1 = (value) => value != +value;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: "number",
      check(value) {
        if (value instanceof Number)
          value = value.valueOf();
        return typeof value === "number" && !isNaN$1(value);
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce)
          return value;
        let parsed = value;
        if (typeof parsed === "string") {
          parsed = parsed.replace(/\s/g, "");
          if (parsed === "")
            return NaN;
          parsed = +parsed;
        }
        if (ctx.isType(parsed) || parsed === null)
          return parsed;
        return parseFloat(parsed);
      });
    });
  }
  min(min, message = number.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(min);
      }
    });
  }
  max(max, message = number.max) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(max);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        less
      },
      skipAbsent: true,
      test(value) {
        return value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        more
      },
      skipAbsent: true,
      test(value) {
        return value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: "integer",
      message,
      skipAbsent: true,
      test: (val) => Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform((value) => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ["ceil", "floor", "round", "trunc"];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || "round";
    if (method === "trunc")
      return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1)
      throw new TypeError("Only valid options for round() are: " + avail.join(", "));
    return this.transform((value) => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$5.prototype = NumberSchema.prototype;
let invalidDate = /* @__PURE__ */ new Date("");
let isDate = (obj) => Object.prototype.toString.call(obj) === "[object Date]";
class DateSchema extends Schema {
  constructor() {
    super({
      type: "date",
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value) || value === null)
          return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast))
        throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, "min");
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, "max");
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = /* @__PURE__ */ new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`))
      edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling)
      addNode(value.path, key);
    else if (isSchema(value) && "deps" in value)
      value.deps.forEach((path) => addNode(path, key));
  }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys2) {
  return (a, b) => {
    return findIndex(keys2, a) - findIndex(keys2, b);
  };
}
const parseJson = (value, _, ctx) => {
  if (typeof value !== "string") {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
  }
  return ctx.isType(parsed) ? parsed : value;
};
function deepPartial(schema) {
  if ("fields" in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === "array") {
    const nextArray = schema.optional();
    if (nextArray.innerType)
      nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === "tuple") {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ("optional" in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...propertyExpr.normalizePath(p)];
  if (path.length === 1)
    return path[0] in obj;
  let last = path.pop();
  let parent = propertyExpr.getter(propertyExpr.join(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject2 = (obj) => Object.prototype.toString.call(obj) === "[object Object]";
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter((key) => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: "object",
      check(value) {
        return isObject2(value) || typeof value === "function";
      }
    });
    this.fields = /* @__PURE__ */ Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);
    if (value === void 0)
      return this.getDefault(options);
    if (!this._typeCheck(value))
      return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter((v) => !this._nodes.includes(v)));
    let intermediateValue = {};
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = prop in value;
      if (field) {
        let fieldValue;
        let inputValue = value[prop];
        innerOptions.path = (options.path ? `${options.path}.` : "") + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : void 0;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ? (
          // TODO: use _cast, this is double resolving
          field.cast(value[prop], innerOptions)
        ) : value[prop];
        if (fieldValue !== void 0) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject2(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, (fieldErrors) => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === void 0 ? schemaOrRef : target;
    }
    return next.withMutation((s) => (
      // XXX: excludes here is wrong
      s.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges])
    ));
  }
  _getDefault(options) {
    if ("default" in this.spec) {
      return super._getDefault(options);
    }
    if (!this._nodes.length) {
      return void 0;
    }
    let dft = {};
    this._nodes.forEach((key) => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : void 0;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    if (excludedEdges)
      next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation((next) => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0]))
          excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys2) {
    const picked = {};
    for (const key of keys2) {
      if (this.fields[key])
        picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a, b]) => keys2.includes(a) && keys2.includes(b)));
  }
  omit(keys2) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys2.includes(key))
        continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform((obj) => {
      if (!obj)
        return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias)
          delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== "boolean") {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: "noUnknown",
      exclusive: true,
      message,
      test(value) {
        if (value == null)
          return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(", ")
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform((obj) => {
      if (!obj)
        return obj;
      const result = {};
      for (const key of Object.keys(obj))
        result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys((key) => tinyCase.snakeCase(key).toUpperCase());
  }
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(next.fields)) {
      var _innerOptions2;
      let innerOptions = options;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;
const {
  input: { current_age: current_age$1, retirement_age: retirement_age$1, annual_income: annual_income$1 },
  slider: { monthly_contribution: monthly_contribution$1, investment_return: investment_return$1 }
} = FIELDS;
const CalculatorSchema = create$3().shape({
  current_age: create$5().min(current_age$1.min, current_age$1.error.min).max(current_age$1.max, current_age$1.error.max).integer(current_age$1.error.integer).required(current_age$1.error.required).typeError(current_age$1.error.typeError),
  retirement_age: create$5().when("current_age", ([current_age2], schema) => {
    const minLimit = current_age2 ? parseInt(current_age2, 10) + 1 : retirement_age$1.min;
    const errorMessage = retirement_age$1.error.current_age.replace(
      "[LIMIT]",
      minLimit
    );
    return schema.min(minLimit, errorMessage);
  }).max(retirement_age$1.max, retirement_age$1.error.max).integer(retirement_age$1.error.integer).required(retirement_age$1.error.required).typeError(retirement_age$1.error.typeError),
  annual_income: create$5().min(annual_income$1.min, annual_income$1.error.min).max(annual_income$1.max, annual_income$1.error.max).integer(annual_income$1.error.integer).required(annual_income$1.error.required).typeError(annual_income$1.error.typeError),
  monthly_contribution: create$5().when("current_age", ([current_age2], schema) => {
    const {
      input: {
        current_age: { ageLimit }
      },
      slider: {
        monthly_contribution: { max, max_alternative }
      }
    } = FIELDS;
    const numCurrentAge = current_age2 ? parseInt(current_age2, 10) : 0;
    const maxLimit = numCurrentAge >= ageLimit ? max_alternative : max;
    return schema.max(
      maxLimit,
      monthly_contribution$1.error.current_age.replace("[LIMIT]", maxLimit)
    );
  }).min(monthly_contribution$1.min, monthly_contribution$1.error.min).integer(monthly_contribution$1.error.integer).required(monthly_contribution$1.error.required).typeError(monthly_contribution$1.error.typeError),
  investment_return: create$5().min(investment_return$1.min, investment_return$1.error.min).max(investment_return$1.max, investment_return$1.error.max).integer(investment_return$1.error.integer).required(investment_return$1.error.required).typeError(investment_return$1.error.typeError)
});
const buildFormData = (values, touched, errors) => {
  const { current_age: currentAgeValue } = values;
  const { input: inputsData, slider: slidersData } = FIELDS;
  const {
    monthly_contribution: { max_alternative: monthlyContributionMaxAlt }
  } = slidersData;
  const {
    current_age: { ageLimit: currentAgeAgeLimit }
  } = inputsData;
  const resp = {};
  Object.keys(inputsData).forEach((fieldName) => {
    resp[fieldName] = touched[fieldName] && errors[fieldName] ? {
      hintText: errors[fieldName],
      variant: "error"
    } : {
      hintText: null,
      variant: "default"
    };
  });
  Object.keys(slidersData).forEach((fieldName) => {
    const hasError = !!errors[fieldName];
    resp[fieldName] = {
      hintText: hasError ? errors[fieldName] : null,
      variant: hasError ? "error" : "default",
      min: slidersData[fieldName].min,
      max: slidersData[fieldName].max,
      defaultValue: slidersData[fieldName].defaultValue
    };
  });
  if (resp.current_age.variant === "default" && currentAgeValue && currentAgeValue >= currentAgeAgeLimit) {
    resp.monthly_contribution.max = monthlyContributionMaxAlt;
  }
  return resp;
};
const getBigDifferenceCopy = (showWarnAnnualIncome, showWarnMonthlyContribution) => {
  const {
    content: { defaultContent: defaultContent2, exceedIncomeLimit, contributionLimit }
  } = BIG_DIFFERENCE;
  if (showWarnAnnualIncome) {
    return exceedIncomeLimit;
  }
  if (showWarnMonthlyContribution) {
    return contributionLimit;
  }
  return defaultContent2;
};
const isDefaultResultsHidden = (showResults, xs) => !showResults && xs;
const maskNumberMoney = (num) => `$${num.toLocaleString("en-US")}`;
const FormRowInput = ({
  label,
  fieldName,
  formData,
  icon = void 0,
  iconAlignment = null
}) => {
  const {
    values: { [fieldName]: fieldValue },
    handleChange,
    handleBlur
  } = useFormikContext();
  const { hintText, variant } = formData;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "space-between", spacing: 0.5, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignItems: "center", sx: { height: "3rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { htmlFor: fieldName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { fontWeight: "light" }, variant: "18", children: label }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { width: "150px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputField,
      {
        hintText,
        icon,
        iconAlignment,
        name: fieldName,
        onBlur: handleBlur,
        onChange: handleChange,
        sx: { mt: 0, mb: variant === "error" ? 0.5 : 1.5 },
        type: "text",
        value: fieldValue,
        variant
      }
    ) })
  ] });
};
const FormRowSlider = ({
  fieldName,
  formData,
  label,
  icon = void 0,
  iconAlignment = null,
  lastOne = false
}) => {
  const {
    values: { [fieldName]: fieldValue },
    setFieldTouched,
    setFieldValue
  } = useFormikContext();
  const { hintText, variant, min, max, defaultValue } = formData;
  const handleThumbChange = useCallback(
    (newValue) => {
      setFieldTouched(fieldName);
      setFieldValue(fieldName, newValue, true);
    },
    [setFieldTouched, setFieldValue, fieldName]
  );
  const handleInputChange = useCallback(
    ({ targetValue, setInputValue, setSliderValue }) => {
      setFieldTouched(fieldName);
      setFieldValue(fieldName, targetValue, true);
      setInputValue(targetValue);
      setSliderValue(targetValue);
    },
    [setFieldTouched, setFieldValue, fieldName]
  );
  let styleInput = { mt: 0 };
  if (lastOne) {
    styleInput = { ...styleInput, mb: 0 };
  } else {
    styleInput = { ...styleInput, mb: variant === "error" ? 0.5 : 1.5 };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", spacing: 0.5, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { htmlFor: fieldName, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { fontWeight: "light" }, variant: "18", children: label }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Slider, { defaultValue, max, min, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Slider.SingleThumbRange,
        {
          onChangeEnd: handleThumbChange,
          sx: { mr: 1.5 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { minWidth: "150px" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Slider.Input,
        {
          hintText,
          icon,
          iconAlignment,
          name: fieldName,
          onChange: handleInputChange,
          sx: styleInput,
          type: "text",
          value: fieldValue,
          variant
        }
      ) })
    ] }) })
  ] });
};
var reWhitespace = /\s/;
function trimmedEndIndex(string2) {
  var index = string2.length;
  while (index-- && reWhitespace.test(string2.charAt(index))) {
  }
  return index;
}
var reTrimStart = /^\s+/;
function baseTrim(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
function setCacheHas(value) {
  return this.__data__.has(value);
}
function SetCache(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
function arraySome(array2, predicate) {
  var index = -1, length = array2 == null ? 0 : array2.length;
  while (++index < length) {
    if (predicate(array2[index], index, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas(cache, key) {
  return cache.has(key);
}
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays(array2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array2);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array2, other);
  stack.set(other, array2);
  while (++index < arrLength) {
    var arrValue = array2[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array2, stack) : customizer(arrValue, othValue, index, array2, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array2);
  stack["delete"](other);
  return result;
}
function mapToArray(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
function setToArray(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag(object2, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq(+object2, +other);
    case errorTag:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag:
    case stringTag$1:
      return object2 == other + "";
    case mapTag:
      var convert = mapToArray;
    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object2, other);
      var result = equalArrays(convert(object2), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects(object2, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object2);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack.set(object2, other);
  stack.set(other, object2);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack) : customizer(objValue, othValue, key, object2, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object2);
  stack["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep(object2, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object2), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag$1(object2), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object2)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack);
}
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
var now = function() {
  return root.Date.now();
};
var FUNC_ERROR_TEXT = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce(func, wait, options) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = "maxWait" in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options ? !!options.trailing : trailing;
  }
  function invokeFunc(time) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time) {
    lastInvokeTime = time;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time) : result;
  }
  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    timerId = setTimeout(timerExpired, remainingWait(time));
  }
  function trailingEdge(time) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time = now(), isInvoking = shouldInvoke(time);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}
var stringTag = "[object String]";
function isString2(value) {
  return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
const CalcResultsContext = createContext();
const initialResults = {
  // Flag used to show the default result panel message. After any form value
  // changes this flag is true forever to show the 'correct form errors'
  // message instead.
  isFormDirty: false,
  // Flag to show default panel or calculation results
  showResults: false,
  // Value shown under 'Guideline 401(k)'
  guidelineTotalSavings: "",
  // Value shown under 'Calsavers Roth IRA'
  calSaversTotalSavings: "",
  // Value shown inside savings message under Guideline and Calsaver results
  savings: "",
  // Flag to show form warning under 'annual income' and Big Difference copy
  showWarnAnnualIncome: false,
  // Flag to show secondary form warning under 'annual income'
  showWarnReducedMonthlyContribution: false,
  // Flag to show warning under 'monthly contribution' and Big Difference copy
  showWarnMonthlyContribution: false
};
const CalcResultsProvider = ({ onFormSubmitCallback, children }) => {
  const [results, setResults] = useState(initialResults);
  const handleResults = (calculationResults) => {
    const {
      calSaversTotalSavings,
      guidelineTotalSavings,
      warnings = {}
    } = calculationResults;
    const {
      maxIncomeExceeded,
      maxIraContributionExceeded,
      reducedMonthlyContributionAmount
    } = warnings;
    const showWarnAnnualIncome = maxIncomeExceeded !== void 0;
    const showWarnReducedMonthlyContribution = reducedMonthlyContributionAmount !== void 0;
    const showWarnMonthlyContribution = maxIraContributionExceeded !== void 0;
    const difference = guidelineTotalSavings - calSaversTotalSavings;
    setResults({
      isFormDirty: true,
      showResults: true,
      calSaversTotalSavings,
      guidelineTotalSavings,
      savings: difference,
      showWarnAnnualIncome,
      showWarnReducedMonthlyContribution,
      showWarnMonthlyContribution
    });
  };
  const resetResults = () => {
    const { isFormDirty } = results;
    setResults({ ...initialResults, isFormDirty });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CalcResultsContext.Provider,
    {
      value: {
        onFormSubmitCallback,
        results,
        handleResults,
        resetResults
      },
      children
    }
  );
};
const createDebouncedFunction = () => debounce(
  async (formikProps, resetResults, onFormSubmitCallback) => {
    try {
      await formikProps.submitForm();
      try {
        const responseObject = await formikProps.validateForm();
        if (Object.keys(responseObject).length > 0) {
          resetResults();
        } else {
          onFormSubmitCallback(formikProps.values);
        }
      } catch (error) {
        resetResults();
      }
    } catch (error) {
      resetResults();
    }
  },
  500,
  { maxWait: 1500, trailing: true }
);
const SubmitListener = () => {
  const formikProps = useFormikContext();
  const { onFormSubmitCallback, resetResults } = useContext(CalcResultsContext);
  const [lastValues, updateState] = useState(formikProps.values);
  const debouncedSubmitRef = useRef(createDebouncedFunction());
  useEffect(() => {
    const valuesEqualLastValues = isEqual(lastValues, formikProps.values);
    const valuesEqualInitialValues = isEqual(
      formikProps.values,
      formikProps.initialValues
    );
    if (!valuesEqualLastValues) {
      updateState(formikProps.values);
    }
    const formHasAllValues = FIELD_NAMES.map(
      (fieldName) => !!(formikProps.values[fieldName] || formikProps.values[fieldName] === 0)
    ).filter((value) => value === false).length === 0;
    if (!valuesEqualLastValues && !valuesEqualInitialValues && formHasAllValues) {
      debouncedSubmitRef.current(
        formikProps,
        resetResults,
        onFormSubmitCallback
      );
    } else if (!valuesEqualLastValues) {
      resetResults();
    }
  }, [lastValues, formikProps, resetResults]);
  return null;
};
const {
  warnAnnualIncome,
  warnReducedMonthlyContribution,
  warnMonthlyContribution
} = FORM;
const iconDollar = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "dollar", size: IconSizes.Icon16, stroke: "text.primary" });
const iconPercent = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "percent", size: IconSizes.Icon16, stroke: "text.primary" });
const getWarnMessage = (message) => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { backgroundColor: "fog-05", mt: 1, mb: 1.5, borderRadius: 4 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  Paragraph,
  {
    color: "text.primary",
    sx: { fontWeight: "light", m: 1 },
    variant: "16",
    children: message
  }
) });
const FormContent = () => {
  const {
    results: {
      showWarnAnnualIncome,
      showWarnReducedMonthlyContribution,
      showWarnMonthlyContribution
    }
  } = useContext(CalcResultsContext);
  const {
    input: {
      current_age: { label: labelCurrentAge },
      retirement_age: { label: labelRetirementAge },
      annual_income: { label: labelAnnualIncome }
    },
    slider: {
      monthly_contribution: { label: labelMonthlyContribution },
      investment_return: { label: labelInvestmentReturn }
    }
  } = FIELDS;
  const formikProps = useFormikContext();
  const { values, errors, touched } = formikProps;
  const {
    current_age: currentAgeFormData,
    retirement_age: retirementAgeFormData,
    annual_income: annualIncomeFormData,
    monthly_contribution: monthlyContributionFormData,
    investment_return: investmentReturnFormData
  } = buildFormData(values, touched, errors);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(SubmitListener, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormRowInput,
      {
        fieldName: "current_age",
        formData: currentAgeFormData,
        iconAlignment: "leading",
        label: labelCurrentAge
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormRowInput,
      {
        fieldName: "retirement_age",
        formData: retirementAgeFormData,
        iconAlignment: "leading",
        label: labelRetirementAge
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormRowInput,
      {
        fieldName: "annual_income",
        formData: annualIncomeFormData,
        icon: iconDollar,
        iconAlignment: "leading",
        label: labelAnnualIncome
      }
    ),
    showWarnAnnualIncome && getWarnMessage(warnAnnualIncome),
    showWarnReducedMonthlyContribution && getWarnMessage(warnReducedMonthlyContribution),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormRowSlider,
      {
        fieldName: "monthly_contribution",
        formData: monthlyContributionFormData,
        icon: iconDollar,
        iconAlignment: "leading",
        label: labelMonthlyContribution
      }
    ),
    showWarnMonthlyContribution && getWarnMessage(warnMonthlyContribution),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      FormRowSlider,
      {
        fieldName: "investment_return",
        formData: investmentReturnFormData,
        icon: iconPercent,
        iconAlignment: "trailing",
        label: labelInvestmentReturn,
        lastOne: true
      }
    )
  ] });
};
const calculatorInstance = new Calculator();
const {
  input: { current_age, retirement_age, annual_income },
  slider: { monthly_contribution, investment_return }
} = FIELDS;
const formikInitValues = {
  current_age: current_age.defaultValue,
  retirement_age: retirement_age.defaultValue,
  annual_income: annual_income.defaultValue,
  monthly_contribution: monthly_contribution.defaultValue,
  investment_return: investment_return.defaultValue
};
const CalculatorForm = () => {
  const { handleResults } = useContext(CalcResultsContext);
  const processSubmit = useCallback(
    (values, formikBag) => {
      const { setSubmitting } = formikBag;
      setSubmitting(false);
      const currentAge = parseInt(values.current_age, 10);
      const retirementAge = parseInt(values.retirement_age, 10);
      const investmentReturn = values.investment_return / 100;
      const monthlyContribution = values.monthly_contribution;
      const yearlyIncome = parseInt(values.annual_income, 10);
      const result = calculatorInstance.calculate({
        currentAge,
        retirementAge,
        investmentReturn,
        monthlyContribution,
        yearlyIncome
      });
      handleResults(result);
    },
    [handleResults]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Formik,
    {
      initialValues: formikInitValues,
      onSubmit: processSubmit,
      validateOnChange: false,
      validationSchema: CalculatorSchema,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Form, { style: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormContent, {}) })
    }
  );
};
const UrlLink = ({ url }) => {
  const [strHttp, strUrlSuffix] = url.split("//");
  const spanDashes = /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { letterSpacing: "0.1em", marginRight: "-0.1em" }, children: "//" });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Link, { href: url, children: [
    strHttp,
    spanDashes,
    strUrlSuffix
  ] });
};
const { sections, guidelineFeesFooter, calSaversFeesFooter } = ASSUMPTIONS_DISCLOSURES_MODAL;
let idCounter = 0;
const getUniqueId = () => {
  idCounter += 1;
  return `modalItemId${idCounter}`;
};
const renderFooter = /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { color: "text.primary", sx: { mb: 0, fontWeight: "light" }, children: [
    guidelineFeesFooter.textA,
    /* @__PURE__ */ jsxRuntimeExports.jsx(UrlLink, { url: guidelineFeesFooter.link1 }),
    guidelineFeesFooter.textB,
    /* @__PURE__ */ jsxRuntimeExports.jsx(UrlLink, { url: guidelineFeesFooter.link2 }),
    guidelineFeesFooter.textC
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { color: "text.primary", sx: { fontWeight: "light" }, children: [
    calSaversFeesFooter.textA,
    /* @__PURE__ */ jsxRuntimeExports.jsx(UrlLink, { url: calSaversFeesFooter.link1 }),
    calSaversFeesFooter.textB
  ] })
] });
const renderItemContent = (item) => {
  if (item.subItems) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { color: "text.primary", sx: { mb: 0 }, variant: "16", children: item.parentItem }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { style: { margin: "0", paddingInlineStart: "1.5rem" }, children: item.subItems.map((subItem) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { color: "text.primary", sx: { mb: 0 }, variant: "16", children: [
        subItem.textA,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: subItem.linkTo, children: subItem.textB })
      ] }) }, getUniqueId())) })
    ] });
  }
  if (item.linkTo) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { color: "text.primary", sx: { mb: 0 }, variant: "16", children: [
      item.textA,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: item.linkTo, children: item.textB }),
      item.textC
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { color: "text.primary", children: item });
};
const DisclosuresModal = () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
  sections.map((section) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", sx: { mb: 2.5 }, children: [
      section.title && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Title,
        {
          as: "div",
          bottomSpace: 0.5,
          color: "text.primary",
          sx: { fontWeight: "light" },
          variant: "24",
          children: section.title
        }
      ),
      (section == null ? void 0 : section.content) && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Paragraph,
        {
          color: "text.primary",
          sx: { mb: (section == null ? void 0 : section.listItems) ? 0 : 1 },
          variant: "16",
          children: section.content
        }
      ),
      (section == null ? void 0 : section.listItems) && /* @__PURE__ */ jsxRuntimeExports.jsx(
        "ul",
        {
          style: { margin: "0.25rem 0 0 0", paddingInlineStart: "1.5rem" },
          children: section.listItems.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: renderItemContent(item) }, getUniqueId()))
        }
      )
    ] }, getUniqueId());
  }),
  renderFooter
] });
const {
  modalTitle,
  linkLabel,
  urlContent3,
  urlContent5,
  urlContent8,
  urlContent10,
  content1: content1$1,
  content2: content2$1,
  content3,
  content4,
  content5,
  content6,
  content7,
  content8,
  content9,
  content10,
  content11
} = ASSUMPTIONS_DISCLOSURES;
const AssumptionsDisclosures = () => {
  const {
    matchMediaQuery: { xs }
  } = useMatchMedia();
  const {
    results: { showResults }
  } = useContext(CalcResultsContext);
  const [modalVisible, setModalVisible] = useState(false);
  const toggleModal = useCallback(
    (event) => {
      event.preventDefault();
      setModalVisible(!modalVisible);
    },
    [modalVisible]
  );
  const contentStyle = { fontWeight: "light", mb: 0 };
  const contentVariant = xs ? "12" : "14";
  const cardContentPaddingTop = isDefaultResultsHidden(showResults, xs) ? 0 : 1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Card, { sx: { boxShadow: "none" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Card.Content,
      {
        sx: {
          pt: cardContentPaddingTop,
          pb: 0,
          px: 0,
          flexDirection: "column"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { mb: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: toggleModal, variant: "secondary", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { sx: { mb: 0 }, variant: "16", children: linkLabel }) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { sx: contentStyle, variant: contentVariant, children: content1$1 }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { sx: contentStyle, variant: contentVariant, children: [
            content2$1,
            /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: urlContent3, children: content3 }),
            content4,
            /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: urlContent5, children: content5 }),
            content6
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { sx: contentStyle, variant: contentVariant, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "1" }),
            content7,
            /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: urlContent8, children: content8 }),
            content9,
            /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: urlContent10, children: content10 }),
            content11
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Modal,
      {
        informational: true,
        isOpen: modalVisible,
        onDismiss: toggleModal,
        onPrimaryAction: toggleModal,
        primaryActionText: "Close",
        size: "large",
        title: modalTitle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(DisclosuresModal, {})
      }
    )
  ] });
};
const { title401k, titleIRA, subtitle, noResultsPlaceholder } = ESTIMATED_TOTAL_SAVINGS;
const styleTitleBase = {
  width: "fit-content",
  fontWeight: "light",
  borderRadius: 4,
  px: 0.5,
  py: 0.25
};
const styleTitle401k = {
  ...styleTitleBase,
  backgroundColor: "eggplant-10"
};
const styleTitleIRA = {
  ...styleTitleBase,
  backgroundColor: "fog-07"
};
const EstimatedTotalSavings = ({ resultValue, isIRA = false }) => {
  const {
    matchMediaQuery: { xs, xl }
  } = useMatchMedia();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Title,
      {
        as: "div",
        color: isIRA ? "fog-70" : "eggplant-95",
        sx: isIRA ? styleTitleIRA : styleTitle401k,
        variant: "18",
        children: isIRA ? titleIRA : title401k
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Title,
      {
        as: "div",
        sx: {
          fontWeight: "light",
          mt: xs ? 1 : 1.5
        },
        variant: xl ? "40" : "32",
        children: resultValue > 0 ? maskNumberMoney(resultValue) : noResultsPlaceholder
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { sx: { mb: 0, mt: xl ? 1 : 0.5 }, variant: "14", children: subtitle })
  ] });
};
const SvgSavingMore = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  "svg",
  {
    fill: "none",
    height: 24,
    width: 27,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        d: "M9.13 23.26c-.365.987-1.76.987-2.126 0l-1.51-4.084a1.133 1.133 0 0 0-.67-.67L.74 16.997c-.987-.365-.987-1.76 0-2.126l4.084-1.511c.31-.115.554-.36.67-.67l1.51-4.083c.365-.987 1.761-.987 2.126 0l1.511 4.083c.115.31.36.555.67.67l4.083 1.511c.987.365.987 1.76 0 2.126l-4.083 1.51c-.31.116-.555.36-.67.67L9.13 23.26ZM21.631 11.097a.567.567 0 0 1-1.063 0l-1.214-3.283a.567.567 0 0 0-.335-.334l-3.283-1.215a.567.567 0 0 1 0-1.063l3.283-1.215a.567.567 0 0 0 .335-.334L20.568.37a.567.567 0 0 1 1.063 0l1.215 3.283c.057.155.18.277.335.334l3.282 1.215a.567.567 0 0 1 0 1.063L23.181 7.48a.567.567 0 0 0-.335.334l-1.215 3.283Z",
        fill: "#230F91"
      }
    )
  }
);
const { content1, content2 } = SAVING_MORE;
const SavingMore = ({ savingValue = "" }) => {
  const {
    matchMediaQuery: { xs }
  } = useMatchMedia();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Card,
    {
      sx: {
        backgroundColor: "eggplant-10",
        border: "default",
        borderColor: "eggplant-40",
        mx: xs ? 0 : 1.5
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Card.Content, { sx: { p: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$1, { spacing: "1", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: "fit-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SvgSavingMore, {}) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: "fill", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Title,
          {
            as: "div",
            color: "eggplant-95",
            sx: { fontWeight: "light" },
            variant: "20",
            children: [
              content1,
              maskNumberMoney(savingValue),
              content2
            ]
          }
        ) })
      ] }) })
    }
  );
};
const { title: title$1 } = BIG_DIFFERENCE;
const BigDifference = ({
  showWarnAnnualIncome,
  showWarnMonthlyContribution
}) => {
  const {
    matchMediaQuery: { xs }
  } = useMatchMedia();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { sx: { boxShadow: "none" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Card.Content,
    {
      sx: {
        px: xs ? 0 : 1.5,
        py: 1.5,
        flexDirection: "column",
        gap: 0.5
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", variant: "18", children: title$1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph,
          {
            color: "text.primary",
            sx: { fontWeight: "light", mb: 0.5 },
            variant: "16",
            children: getBigDifferenceCopy(
              showWarnAnnualIncome,
              showWarnMonthlyContribution
            )
          }
        )
      ]
    }
  ) });
};
const { title, content, buttonLabel, getStartedUrl } = HAVE_FIVE_PLUS_EMPLOYEES;
const handleGetSarted = () => {
  document.location = getStartedUrl;
};
const HaveFivePlusEmployees = () => {
  const {
    matchMediaQuery: { xs }
  } = useMatchMedia();
  let cardStyle = {
    backgroundColor: "fog-05",
    boxShadow: "none"
  };
  if (xs) {
    cardStyle = {
      ...cardStyle,
      mx: 0
    };
  } else {
    cardStyle = {
      ...cardStyle,
      borderTop: "default",
      borderColor: "fog-15",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    };
  }
  let cardContentStyle = {
    flexGrow: 1,
    alignItems: "center"
  };
  if (xs) {
    cardContentStyle = {
      ...cardContentStyle,
      p: 1,
      justifyContent: "start",
      flexDirection: "column",
      gap: 1.5
    };
  } else {
    cardContentStyle = {
      ...cardContentStyle,
      px: 2,
      py: 1.5,
      justifyContent: "space-between",
      flexDirection: "row",
      gap: 0.5
    };
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { sx: cardStyle, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Card.Content, { sx: cardContentStyle, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", variant: "18", children: title }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Paragraph,
        {
          color: "text.primary",
          sx: { fontWeight: "light", mb: 0 },
          variant: "16",
          children: [
            content,
            /* @__PURE__ */ jsxRuntimeExports.jsx("sup", { children: "1" })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { width: xs ? "100%" : void 0, minWidth: "fit-content" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        onClick: handleGetSarted,
        sx: { width: "fit-content", px: 1.5 },
        variant: "primary",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Title,
          {
            as: "span",
            color: "fog-00",
            sx: { fontWeight: "light" },
            variant: "16",
            children: buttonLabel
          }
        )
      }
    ) })
  ] }) });
};
const SvgCalcResultsDefault = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  "svg",
  {
    fill: "none",
    height: 104,
    width: 104,
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("rect", { fill: "#F5F7F9", height: 104, rx: 52, width: 104 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "m62 55.273 5.09 5.09a2.314 2.314 0 1 0 3.273-3.273L65.274 52",
          stroke: "#959CA6",
          strokeLinejoin: "round",
          strokeMiterlimit: 10,
          strokeWidth: 2
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M55 57c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
          stroke: "#959CA6",
          strokeLinejoin: "round",
          strokeMiterlimit: 10,
          strokeWidth: 2
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M49 45.429 52.727 49 61 41",
          stroke: "#959CA6",
          strokeMiterlimit: 10,
          strokeWidth: 2
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          d: "M47 72v-6a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v6M33 72V55a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v17M40 72V61a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v11M32 71h23",
          stroke: "#959CA6",
          strokeWidth: 2
        }
      )
    ]
  }
);
const { defaultContent, errorContent } = CALC_RESULTS_DEFAULT;
const getResultsDefault = (isFormDirty) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Flex,
  {
    flexGrow: "1",
    sx: {
      backgroundColor: "fog-07",
      padding: 2
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { sx: { flexGrow: 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Card.Content,
      {
        sx: {
          flexGrow: 1,
          minHeight: "350px",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(SvgCalcResultsDefault, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Title,
            {
              as: "div",
              color: "fog-30",
              sx: {
                mt: 2,
                textAlign: "center",
                fontWeight: "light"
              },
              variant: "18",
              children: isFormDirty ? errorContent : defaultContent
            }
          )
        ]
      }
    ) })
  }
);
const FormResults = () => {
  const {
    matchMediaQuery: { xs, smUp, lgUp }
  } = useMatchMedia();
  const {
    results: { isFormDirty }
  } = useContext(CalcResultsContext);
  const {
    results: {
      showResults,
      calSaversTotalSavings,
      guidelineTotalSavings,
      savings,
      showWarnAnnualIncome,
      showWarnMonthlyContribution
    }
  } = useContext(CalcResultsContext);
  if (isDefaultResultsHidden(showResults, xs)) {
    return null;
  }
  if (!showResults) {
    return getResultsDefault(isFormDirty);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      sx: {
        flexGrow: 1,
        backgroundColor: smUp ? "fog-15" : "fog-00",
        padding: smUp ? 2 : 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Card, { sx: { flexGrow: 1, boxShadow: xs ? "none" : "elevation.two" }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Card.Content,
        {
          sx: { flexGrow: 1, flexDirection: "column", p: 0, pb: 0 },
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                sx: {
                  px: xs ? 0 : 1.5,
                  pt: 1.5,
                  pb: lgUp ? 2 : 1.5,
                  flexGrow: 1
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Stack$1, { direction: xs ? "column" : "row", spacing: 1.5, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: xs ? 24 : 12, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EstimatedTotalSavings, { resultValue: guidelineTotalSavings }) }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: xs ? 24 : 12, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    EstimatedTotalSavings,
                    {
                      isIRA: true,
                      resultValue: calSaversTotalSavings
                    }
                  ) })
                ] })
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(SavingMore, { savingValue: savings }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              BigDifference,
              {
                showWarnAnnualIncome,
                showWarnMonthlyContribution
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(HaveFivePlusEmployees, {})
          ]
        }
      ) })
    }
  );
};
const getMainGap = (xs, xl) => {
  if (xl) {
    return 6;
  }
  if (xs) {
    return 0.5;
  }
  return 2;
};
const App = () => {
  const {
    matchMediaQuery: { xs, lgUp, xl }
  } = useMatchMedia();
  const {
    results: { showResults }
  } = useContext(CalcResultsContext);
  return useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Flex,
      {
        flexDirection: "column",
        sx: {
          maxWidth: "1200px",
          mx: "auto",
          backgroundColor: "fog-00"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Flex,
            {
              flexDirection: lgUp ? "row" : "column",
              spacing: getMainGap(xs, xl),
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { width: lgUp ? "40%" : "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CalculatorForm, {}) }),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Flex,
                  {
                    sx: {
                      alignSelf: "flex-start",
                      width: lgUp ? "60%" : "100%",
                      mt: lgUp ? 0 : 2
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormResults, {})
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { mt: isDefaultResultsHidden(showResults, xs) ? 0 : 1 }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AssumptionsDisclosures, {}) })
        ]
      }
    ),
    [xs, lgUp, xl, showResults]
  );
};
const noop = () => {
};
const CalSaversCalculator = ({ onFormSubmitCallback = noop }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: legacyMarketingUITheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMediaProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CalcResultsProvider, { onFormSubmitCallback, children: /* @__PURE__ */ jsxRuntimeExports.jsx(App, {}) }) }) });
};
var DP = 20, RM = 1, MAX_DP = 1e6, MAX_POWER = 1e6, NE = -7, PE = 21, STRICT = false, NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function _Big_() {
  function Big2(n) {
    var x = this;
    if (!(x instanceof Big2))
      return n === UNDEFINED ? _Big_() : new Big2(n);
    if (n instanceof Big2) {
      x.s = n.s;
      x.e = n.e;
      x.c = n.c.slice();
    } else {
      if (typeof n !== "string") {
        if (Big2.strict === true && typeof n !== "bigint") {
          throw TypeError(INVALID + "value");
        }
        n = n === 0 && 1 / n < 0 ? "-0" : String(n);
      }
      parse(x, n);
    }
    x.constructor = Big2;
  }
  Big2.prototype = P;
  Big2.DP = DP;
  Big2.RM = RM;
  Big2.NE = NE;
  Big2.PE = PE;
  Big2.strict = STRICT;
  Big2.roundDown = 0;
  Big2.roundHalfUp = 1;
  Big2.roundHalfEven = 2;
  Big2.roundUp = 3;
  return Big2;
}
function parse(x, n) {
  var e, i, nl;
  if (!NUMERIC.test(n)) {
    throw Error(INVALID + "number");
  }
  x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
  if ((e = n.indexOf(".")) > -1)
    n = n.replace(".", "");
  if ((i = n.search(/e/i)) > 0) {
    if (e < 0)
      e = i;
    e += +n.slice(i + 1);
    n = n.substring(0, i);
  } else if (e < 0) {
    e = n.length;
  }
  nl = n.length;
  for (i = 0; i < nl && n.charAt(i) == "0"; )
    ++i;
  if (i == nl) {
    x.c = [x.e = 0];
  } else {
    for (; nl > 0 && n.charAt(--nl) == "0"; )
      ;
    x.e = e - i - 1;
    x.c = [];
    for (e = 0; i <= nl; )
      x.c[e++] = +n.charAt(i++);
  }
  return x;
}
function round(x, sd, rm, more) {
  var xc = x.c;
  if (rm === UNDEFINED)
    rm = x.constructor.RM;
  if (rm !== 0 && rm !== 1 && rm !== 2 && rm !== 3) {
    throw Error(INVALID_RM);
  }
  if (sd < 1) {
    more = rm === 3 && (more || !!xc[0]) || sd === 0 && (rm === 1 && xc[0] >= 5 || rm === 2 && (xc[0] > 5 || xc[0] === 5 && (more || xc[1] !== UNDEFINED)));
    xc.length = 1;
    if (more) {
      x.e = x.e - sd + 1;
      xc[0] = 1;
    } else {
      xc[0] = x.e = 0;
    }
  } else if (sd < xc.length) {
    more = rm === 1 && xc[sd] >= 5 || rm === 2 && (xc[sd] > 5 || xc[sd] === 5 && (more || xc[sd + 1] !== UNDEFINED || xc[sd - 1] & 1)) || rm === 3 && (more || !!xc[0]);
    xc.length = sd;
    if (more) {
      for (; ++xc[--sd] > 9; ) {
        xc[sd] = 0;
        if (sd === 0) {
          ++x.e;
          xc.unshift(1);
          break;
        }
      }
    }
    for (sd = xc.length; !xc[--sd]; )
      xc.pop();
  }
  return x;
}
function stringify(x, doExponential, isNonzero) {
  var e = x.e, s = x.c.join(""), n = s.length;
  if (doExponential) {
    s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
  } else if (e < 0) {
    for (; ++e; )
      s = "0" + s;
    s = "0." + s;
  } else if (e > 0) {
    if (++e > n) {
      for (e -= n; e--; )
        s += "0";
    } else if (e < n) {
      s = s.slice(0, e) + "." + s.slice(e);
    }
  } else if (n > 1) {
    s = s.charAt(0) + "." + s.slice(1);
  }
  return x.s < 0 && isNonzero ? "-" + s : s;
}
P.abs = function() {
  var x = new this.constructor(this);
  x.s = 1;
  return x;
};
P.cmp = function(y) {
  var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
  if (!xc[0] || !yc[0])
    return !xc[0] ? !yc[0] ? 0 : -j : i;
  if (i != j)
    return i;
  isneg = i < 0;
  if (k != l)
    return k > l ^ isneg ? 1 : -1;
  j = (k = xc.length) < (l = yc.length) ? k : l;
  for (i = -1; ++i < j; ) {
    if (xc[i] != yc[i])
      return xc[i] > yc[i] ^ isneg ? 1 : -1;
  }
  return k == l ? 0 : k > l ^ isneg ? 1 : -1;
};
P.div = function(y) {
  var x = this, Big2 = x.constructor, a = x.c, b = (y = new Big2(y)).c, k = x.s == y.s ? 1 : -1, dp = Big2.DP;
  if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  if (!b[0]) {
    throw Error(DIV_BY_ZERO);
  }
  if (!a[0]) {
    y.s = k;
    y.c = [y.e = 0];
    return y;
  }
  var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, p = dp + (q.e = x.e - y.e) + 1;
  q.s = k;
  k = p < 0 ? 0 : p;
  bz.unshift(0);
  for (; rl++ < bl; )
    r.push(0);
  do {
    for (n = 0; n < 10; n++) {
      if (bl != (rl = r.length)) {
        cmp = bl > rl ? 1 : -1;
      } else {
        for (ri = -1, cmp = 0; ++ri < bl; ) {
          if (b[ri] != r[ri]) {
            cmp = b[ri] > r[ri] ? 1 : -1;
            break;
          }
        }
      }
      if (cmp < 0) {
        for (bt = rl == bl ? b : bz; rl; ) {
          if (r[--rl] < bt[rl]) {
            ri = rl;
            for (; ri && !r[--ri]; )
              r[ri] = 9;
            --r[ri];
            r[rl] += 10;
          }
          r[rl] -= bt[rl];
        }
        for (; !r[0]; )
          r.shift();
      } else {
        break;
      }
    }
    qc[qi++] = cmp ? n : ++n;
    if (r[0] && cmp)
      r[rl] = a[ai] || 0;
    else
      r = [a[ai]];
  } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
  if (!qc[0] && qi != 1) {
    qc.shift();
    q.e--;
    p--;
  }
  if (qi > p)
    round(q, p, Big2.RM, r[0] !== UNDEFINED);
  return q;
};
P.eq = function(y) {
  return this.cmp(y) === 0;
};
P.gt = function(y) {
  return this.cmp(y) > 0;
};
P.gte = function(y) {
  return this.cmp(y) > -1;
};
P.lt = function(y) {
  return this.cmp(y) < 0;
};
P.lte = function(y) {
  return this.cmp(y) < 1;
};
P.minus = P.sub = function(y) {
  var i, j, t, xlty, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (a != b) {
    y.s = -b;
    return x.plus(y);
  }
  var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
  if (!xc[0] || !yc[0]) {
    if (yc[0]) {
      y.s = -b;
    } else if (xc[0]) {
      y = new Big2(x);
    } else {
      y.s = 1;
    }
    return y;
  }
  if (a = xe - ye) {
    if (xlty = a < 0) {
      a = -a;
      t = xc;
    } else {
      ye = xe;
      t = yc;
    }
    t.reverse();
    for (b = a; b--; )
      t.push(0);
    t.reverse();
  } else {
    j = ((xlty = xc.length < yc.length) ? xc : yc).length;
    for (a = b = 0; b < j; b++) {
      if (xc[b] != yc[b]) {
        xlty = xc[b] < yc[b];
        break;
      }
    }
  }
  if (xlty) {
    t = xc;
    xc = yc;
    yc = t;
    y.s = -y.s;
  }
  if ((b = (j = yc.length) - (i = xc.length)) > 0)
    for (; b--; )
      xc[i++] = 0;
  for (b = i; j > a; ) {
    if (xc[--j] < yc[j]) {
      for (i = j; i && !xc[--i]; )
        xc[i] = 9;
      --xc[i];
      xc[j] += 10;
    }
    xc[j] -= yc[j];
  }
  for (; xc[--b] === 0; )
    xc.pop();
  for (; xc[0] === 0; ) {
    xc.shift();
    --ye;
  }
  if (!xc[0]) {
    y.s = 1;
    xc = [ye = 0];
  }
  y.c = xc;
  y.e = ye;
  return y;
};
P.mod = function(y) {
  var ygtx, x = this, Big2 = x.constructor, a = x.s, b = (y = new Big2(y)).s;
  if (!y.c[0]) {
    throw Error(DIV_BY_ZERO);
  }
  x.s = y.s = 1;
  ygtx = y.cmp(x) == 1;
  x.s = a;
  y.s = b;
  if (ygtx)
    return new Big2(x);
  a = Big2.DP;
  b = Big2.RM;
  Big2.DP = Big2.RM = 0;
  x = x.div(y);
  Big2.DP = a;
  Big2.RM = b;
  return this.minus(x.times(y));
};
P.neg = function() {
  var x = new this.constructor(this);
  x.s = -x.s;
  return x;
};
P.plus = P.add = function(y) {
  var e, k, t, x = this, Big2 = x.constructor;
  y = new Big2(y);
  if (x.s != y.s) {
    y.s = -y.s;
    return x.minus(y);
  }
  var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
  if (!xc[0] || !yc[0]) {
    if (!yc[0]) {
      if (xc[0]) {
        y = new Big2(x);
      } else {
        y.s = x.s;
      }
    }
    return y;
  }
  xc = xc.slice();
  if (e = xe - ye) {
    if (e > 0) {
      ye = xe;
      t = yc;
    } else {
      e = -e;
      t = xc;
    }
    t.reverse();
    for (; e--; )
      t.push(0);
    t.reverse();
  }
  if (xc.length - yc.length < 0) {
    t = yc;
    yc = xc;
    xc = t;
  }
  e = yc.length;
  for (k = 0; e; xc[e] %= 10)
    k = (xc[--e] = xc[e] + yc[e] + k) / 10 | 0;
  if (k) {
    xc.unshift(k);
    ++ye;
  }
  for (e = xc.length; xc[--e] === 0; )
    xc.pop();
  y.c = xc;
  y.e = ye;
  return y;
};
P.pow = function(n) {
  var x = this, one = new x.constructor("1"), y = one, isneg = n < 0;
  if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) {
    throw Error(INVALID + "exponent");
  }
  if (isneg)
    n = -n;
  for (; ; ) {
    if (n & 1)
      y = y.times(x);
    n >>= 1;
    if (!n)
      break;
    x = x.times(x);
  }
  return isneg ? one.div(y) : y;
};
P.prec = function(sd, rm) {
  if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
    throw Error(INVALID + "precision");
  }
  return round(new this.constructor(this), sd, rm);
};
P.round = function(dp, rm) {
  if (dp === UNDEFINED)
    dp = 0;
  else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) {
    throw Error(INVALID_DP);
  }
  return round(new this.constructor(this), dp + this.e + 1, rm);
};
P.sqrt = function() {
  var r, c, t, x = this, Big2 = x.constructor, s = x.s, e = x.e, half = new Big2("0.5");
  if (!x.c[0])
    return new Big2(x);
  if (s < 0) {
    throw Error(NAME + "No square root");
  }
  s = Math.sqrt(x + "");
  if (s === 0 || s === 1 / 0) {
    c = x.c.join("");
    if (!(c.length + e & 1))
      c += "0";
    s = Math.sqrt(c);
    e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
    r = new Big2((s == 1 / 0 ? "5e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
  } else {
    r = new Big2(s + "");
  }
  e = r.e + (Big2.DP += 4);
  do {
    t = r;
    r = half.times(t.plus(x.div(t)));
  } while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
  return round(r, (Big2.DP -= 4) + r.e + 1, Big2.RM);
};
P.times = P.mul = function(y) {
  var c, x = this, Big2 = x.constructor, xc = x.c, yc = (y = new Big2(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
  y.s = x.s == y.s ? 1 : -1;
  if (!xc[0] || !yc[0]) {
    y.c = [y.e = 0];
    return y;
  }
  y.e = i + j;
  if (a < b) {
    c = xc;
    xc = yc;
    yc = c;
    j = a;
    a = b;
    b = j;
  }
  for (c = new Array(j = a + b); j--; )
    c[j] = 0;
  for (i = b; i--; ) {
    b = 0;
    for (j = a + i; j > i; ) {
      b = c[j] + yc[i] * xc[j - i - 1] + b;
      c[j--] = b % 10;
      b = b / 10 | 0;
    }
    c[j] = b;
  }
  if (b)
    ++y.e;
  else
    c.shift();
  for (i = c.length; !c[--i]; )
    c.pop();
  y.c = c;
  return y;
};
P.toExponential = function(dp, rm) {
  var x = this, n = x.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), ++dp, rm);
    for (; x.c.length < dp; )
      x.c.push(0);
  }
  return stringify(x, true, !!n);
};
P.toFixed = function(dp, rm) {
  var x = this, n = x.c[0];
  if (dp !== UNDEFINED) {
    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) {
      throw Error(INVALID_DP);
    }
    x = round(new x.constructor(x), dp + x.e + 1, rm);
    for (dp = dp + x.e + 1; x.c.length < dp; )
      x.c.push(0);
  }
  return stringify(x, false, !!n);
};
P[Symbol.for("nodejs.util.inspect.custom")] = P.toJSON = P.toString = function() {
  var x = this, Big2 = x.constructor;
  return stringify(x, x.e <= Big2.NE || x.e >= Big2.PE, !!x.c[0]);
};
P.toNumber = function() {
  var n = Number(stringify(this, true, true));
  if (this.constructor.strict === true && !this.eq(n.toString())) {
    throw Error(NAME + "Imprecise conversion");
  }
  return n;
};
P.toPrecision = function(sd, rm) {
  var x = this, Big2 = x.constructor, n = x.c[0];
  if (sd !== UNDEFINED) {
    if (sd !== ~~sd || sd < 1 || sd > MAX_DP) {
      throw Error(INVALID + "precision");
    }
    x = round(new Big2(x), sd, rm);
    for (; x.c.length < sd; )
      x.c.push(0);
  }
  return stringify(x, sd <= x.e || x.e <= Big2.NE || x.e >= Big2.PE, !!n);
};
P.valueOf = function() {
  var x = this, Big2 = x.constructor;
  if (Big2.strict === true) {
    throw Error(NAME + "valueOf disallowed");
  }
  return stringify(x, x.e <= Big2.NE || x.e >= Big2.PE, true);
};
var Big = _Big_();
function isCentsContribution() {
  return true;
}
function isEmployeeCentsContribution(contribution) {
  return contribution.unit === "cents";
}
function isEmployeeRateContribution(contribution) {
  return contribution.unit === "percent";
}
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  isCentsContribution,
  isEmployeeCentsContribution,
  isEmployeeRateContribution
}, Symbol.toStringTag, { value: "Module" }));
function limitContribution(contribution, limit) {
  if (limit == null) {
    return contribution;
  }
  return Math.min(contribution, limit);
}
class ContributionError extends Error {
  constructor({
    message,
    name
  }) {
    super();
    __publicField(this, "name");
    __publicField(this, "message");
    this.message = message;
    this.name = name;
  }
}
function contributionBelowLimit(totalContributionAmount, contributionLimit) {
  if (totalContributionAmount.amount > contributionLimit) {
    throw new ContributionError({
      message: "Total contribution exceeds the employee's contribution limit",
      name: "contribution_exceeds_limit"
    });
  }
  return true;
}
function contributionDoesNotExceedCompensation(totalContributionRate) {
  if (totalContributionRate.amount > 1) {
    throw new ContributionError({
      message: "Contribution rate exceeds 100% of employee's income",
      name: "invalid_contribution_rate"
    });
  }
  return true;
}
function contributionUnitShouldBeTheSame(rothContribution, traditionalContribution) {
  if (rothContribution.unit !== traditionalContribution.unit) {
    throw new ContributionError({
      message: "Contribution unit should be the same",
      name: "contribution_unit_different"
    });
  }
  return true;
}
function rothContributionDoesNotExceedMaxRothContribution(rothContributionRate, maxRothContributionRate) {
  if (rothContributionRate > maxRothContributionRate) {
    throw new ContributionError({
      message: `Roth contribution of ${rothContributionRate} must be less than ${maxRothContributionRate}`,
      name: "roth_contribution_exceeds_limit"
    });
  }
  return true;
}
function sumContributions(...contributions) {
  return contributions.reduce((totalContribution, contribution) => {
    return totalContribution.plus(contribution);
  }, Big(0)).toNumber();
}
const LOW_SALARY_ROTH_CONTRIBUTION_LIMIT_PERCENT = 0.5;
const LOW_SALARY_ROTH_CONTRIBUTION_COMP_THRESHOLD = 1e5;
const EMPLOYEE_CONTRIBUTION_LIMIT_2023 = 225e4;
class ContributionCalculator {
  constructor(config) {
    __publicField(this, "employee");
    __publicField(this, "employer");
    __publicField(this, "ratePrecision");
    __publicField(this, "requestTaxesOwed");
    const {
      employee: {
        contributionLimit,
        currentYearBalance,
        isLowSalary,
        lowSalaryRothContributionLimit,
        maritalStatus,
        payDaysPerYear,
        remainingPayDates,
        rothContribution,
        salary,
        taxState,
        traditionalContribution,
        yearToDateContribution
      },
      employer: {
        match,
        matchContributionLimit,
        nonelectiveContributionLimit,
        nonelectiveContributionRate,
        remainingContribution
      },
      ratePrecision,
      requestTaxesOwed
    } = config;
    this.employee = {
      contributionLimit: contributionLimit ?? EMPLOYEE_CONTRIBUTION_LIMIT_2023,
      currentYearBalance: currentYearBalance ?? 0,
      isLowSalary: isLowSalary || salary && salary < LOW_SALARY_ROTH_CONTRIBUTION_COMP_THRESHOLD || false,
      lowSalaryRothContributionLimit: lowSalaryRothContributionLimit ?? LOW_SALARY_ROTH_CONTRIBUTION_LIMIT_PERCENT,
      maritalStatus: maritalStatus ?? "single",
      payDaysPerYear: payDaysPerYear ?? 24,
      remainingPayDates: remainingPayDates ?? [],
      rothContribution: rothContribution ?? {
        amount: 0,
        unit: "percent"
      },
      salary: salary ?? 0,
      taxState: taxState ?? "CA",
      traditionalContribution: traditionalContribution ?? {
        amount: 0,
        unit: "percent"
      },
      yearToDateContribution: yearToDateContribution ?? 0
    };
    this.employer = {
      match: match ?? [{ rate: 0, limit: 0, offset: 0 }],
      matchContributionLimit: matchContributionLimit ?? 0,
      nonelectiveContributionRate: nonelectiveContributionRate ?? 0,
      nonelectiveContributionLimit: nonelectiveContributionLimit ?? 0,
      remainingContribution
    };
    this.employer.match.sort(
      ({ limit: limitA }, { limit: limitB }) => limitB - limitA
    );
    this.ratePrecision = ratePrecision ?? 4;
    this.requestTaxesOwed = requestTaxesOwed;
  }
  /**
   * Number of contributions per year
   */
  contributionFrequency() {
    return this.employee.payDaysPerYear > 0 ? this.employee.payDaysPerYear : null;
  }
  /**
   * Annual contribution limit defined by the IRS
   * Limits the combined employee / employer contributions
   */
  contributionLimit() {
    return this.employee.contributionLimit;
  }
  currentYearBalance() {
    return this.employee.currentYearBalance;
  }
  /**
   * Effective employer match rate + employer's nonelective contribution rate
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  effectiveEmployerContributionRate(...employeeContributionOverrides) {
    const match = this.effectiveMatchRate(...employeeContributionOverrides);
    return Big(match).plus(this.employer.nonelectiveContributionRate).round(this.ratePrecision).toNumber();
  }
  /**
   * Returns the resulting match % based on an employee contribution
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  effectiveMatchRate(...employeeContributionOverrides) {
    const employeeContributionRate = this.normalizedEmployeeContributionRate(
      employeeContributionOverrides
    );
    let effectiveRate = Big(0);
    this.employer.match.forEach(({ limit, offset, rate }) => {
      const matchLimitedRate = Big(Math.min(employeeContributionRate, limit));
      let effective = Big(matchLimitedRate).minus(offset);
      if (effective.gt(0)) {
        effective = effective.times(rate);
        effectiveRate = effectiveRate.plus(effective);
      }
    });
    return effectiveRate.round(this.ratePrecision).toNumber();
  }
  /**
   * Amount the employee is estimated to contribute annually based on contribution rate and salary
   * Note: Use projectedYearEndContribution if trying to get the more accurate value at the end of the year as employeeAnnualContribution
   * does not take account of current contributions
   * Includes both traditional and roth contributions
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  employeeAnnualContribution(...employeeContributionOverrides) {
    const normalizedContributionRates = employeeContributionOverrides.length > 0 ? employeeContributionOverrides.map(
      (contribution) => this.normalizedEmployeeContributionRate(contribution)
    ) : [this.normalizedEmployeeContributionRate()];
    const estimatedAnnualContribution = normalizedContributionRates.reduce(
      (totalContribution, rate) => Big(this.employee.salary).times(rate).plus(totalContribution),
      Big(0)
    ).round().toNumber();
    return limitContribution(
      estimatedAnnualContribution,
      this.employee.contributionLimit
    );
  }
  /**
   * Annual contribution limit for the employee
   */
  employeeContributionLimit() {
    return this.employee.contributionLimit;
  }
  /**
   * Number of pay periods remaining for the year after the max out date
   * in which the employee would not receive any employer contributions
   * @returns null if employee will not max out their annual contribution
   */
  employeeForfeitedPayPeriods(...employeeContributionOverrides) {
    const maxOutDate = this.employeeMaxOutDate(
      ...employeeContributionOverrides
    );
    if (maxOutDate) {
      return this.remainingPayPeriods() - (this.remainingPayDates().indexOf(maxOutDate) + 1);
    }
    return null;
  }
  /**
   * Estimated date employee will have maxed their annual contribution
   */
  employeeMaxOutDate(...employeeContributionOverrides) {
    const remainingAnnualContribution = this.employeeContributionLimit() - this.currentYearBalance();
    const employeePayPeriodContribution = this.employeePayPeriodContribution(
      ...employeeContributionOverrides
    );
    if (employeePayPeriodContribution === 0) {
      return null;
    }
    const payPeriodsUntilMax = Big(remainingAnnualContribution).div(employeePayPeriodContribution).round(0, 3).toNumber();
    if (payPeriodsUntilMax > this.remainingPayPeriods()) {
      return null;
    }
    return this.remainingPayDates()[payPeriodsUntilMax - 1];
  }
  /**
   * Amount the employee contributes per pay period, both traditional and roth
   * @param employeeContributionOverride Used to override config value for one off calculations
   */
  employeePayPeriodContribution(...employeeContributionOverrides) {
    return this.totalEmployeeContribution(...employeeContributionOverrides).amount;
  }
  /**
   * Amount the employer contributes annually in nonelective contributions
   */
  employerAnnualNonelectiveContribution() {
    return Big(this.employee.salary).times(this.employer.nonelectiveContributionRate).round().toNumber();
  }
  /**
   * Amount the employer contributes annually in matching contributions.
   * @param employeeContributionOverride Used to override config value for one off calculations
   */
  employerAnnualMatchContribution(...employeeContributionOverrides) {
    const matchRate = this.effectiveMatchRate(...employeeContributionOverrides);
    return Big(this.employee.salary).times(matchRate).round().toNumber();
  }
  /**
   * Annual match contribution limit for the employer
   */
  employerMatchContributionLimit() {
    return this.employer.matchContributionLimit;
  }
  /**
   * Annual non-elective contribution limit for employer
   */
  employerNonElectiveContributionLimit() {
    return this.employer.nonelectiveContributionLimit;
  }
  /**
   * Amount an employer contributes per pay period.
   * @param employeeContributionOverride Used to override config value for one off calculations
   */
  employerPayPeriodContribution(...employeeContributionOverrides) {
    let total = Big(0);
    total = total.plus(this.employerPayPeriodNonelectiveContribution());
    total = total.plus(
      this.employerPayPeriodMatchContribution(...employeeContributionOverrides)
    );
    return total.toNumber();
  }
  /**
   * Amount the employer contributes per pay period in nonelective contributions
   */
  employerPayPeriodNonelectiveContribution() {
    return Big(this.grossPaycheck()).times(this.employer.nonelectiveContributionRate).round().toNumber();
  }
  /**
   * Amount the employer contributes as a match per pay period
   * @param employeeContributionOverride Used to override config value for one off calculations
   */
  employerPayPeriodMatchContribution(...employeeContributionOverrides) {
    const matchRate = this.effectiveMatchRate(...employeeContributionOverrides);
    return limitContribution(
      Big(this.grossPaycheck()).times(matchRate).round().toNumber(),
      this.employer.remainingContribution
    );
  }
  /**
   * Estimates the taxes the participant owes
   * Used to determine maximum roth contribution rate
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  async estimateTaxesOwed(...employeeContributionOverrides) {
    const { salary, maritalStatus, taxState } = this.employee;
    const adjustedSalary = Math.max(
      salary - this.employeeAnnualContribution(...employeeContributionOverrides),
      0
    );
    return this.requestTaxesOwed(
      adjustedSalary,
      maritalStatus,
      taxState,
      "latest"
    );
  }
  /**
   * Estimated pay per paycheck before contributions, taxes, etc.
   */
  grossPaycheck() {
    const contributionFreq = this.contributionFrequency();
    if (contributionFreq === null || this.employee.salary <= 0) {
      return 0;
    }
    return Big(this.employee.salary).div(contributionFreq).round().toNumber();
  }
  /**
   * Determines required roth and traditional contributions needed to maximize employer's match
   */
  maxOutMatchRate({
    rothContributionOverride,
    traditionalContributionOverride
  } = {}) {
    const currentRothRate = this.normalizedEmployeeContributionRate(
      rothContributionOverride ?? this.employee.rothContribution
    );
    const currentTraditionalRate = this.normalizedEmployeeContributionRate(
      traditionalContributionOverride ?? this.employee.traditionalContribution
    );
    let targetRothContribution = currentRothRate;
    let targetTraditionalContribution = currentTraditionalRate;
    const optimalRate = this.optimalContributionRate();
    if (optimalRate > 0) {
      const currentRothRate2 = this.normalizedEmployeeContributionRate(
        rothContributionOverride ?? this.employee.rothContribution
      );
      const currentTraditionalRate2 = this.normalizedEmployeeContributionRate(
        traditionalContributionOverride ?? this.employee.traditionalContribution
      );
      const currentContributionRate = Big(currentRothRate2).plus(
        currentTraditionalRate2
      );
      if (currentContributionRate.gt(0)) {
        targetRothContribution = Big(currentRothRate2).div(currentContributionRate).times(optimalRate).round(this.ratePrecision).toNumber();
        targetTraditionalContribution = Big(currentTraditionalRate2).div(currentContributionRate).times(optimalRate).round(this.ratePrecision).toNumber();
      } else {
        targetTraditionalContribution = optimalRate;
      }
    }
    return {
      rothContributionRate: targetRothContribution,
      traditionalContributionRate: targetTraditionalContribution
    };
  }
  /**
   * Determines the maximum roth contribution rate
   * @param rothAdjustedGrossIncome Participant's income deducting federal and state taxes and fica
   */
  async maxRothContributionRate() {
    const { isLowSalary, lowSalaryRothContributionLimit, salary } = this.employee;
    if (isLowSalary || salary === 0) {
      return lowSalaryRothContributionLimit;
    }
    const rothAdjustedGrossIncome = await this.rothAdjustedGrossIncome();
    const maxContributionRate = Big(rothAdjustedGrossIncome).div(salary).toNumber();
    return Math.max(maxContributionRate, 0);
  }
  /**
   * Amount that the participant is missing out on per pay period by not contributing
   * the optimal amount that would maximize employer match
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  missingEmployerMatchContribution(...employeeContributionOverrides) {
    const employerAmountForOptimalContributionRate = this.employerAmountForOptimalContributionRate();
    const currentEmployerContribution = this.employerPayPeriodMatchContribution(
      ...employeeContributionOverrides
    );
    const missingContribution = Big(employerAmountForOptimalContributionRate).sub(currentEmployerContribution).round();
    return missingContribution.gt(0) ? missingContribution.toNumber() : 0;
  }
  /**
   * Normalizes the employee contribution to a cent amount
   * @param contributionOverride Used to override config value for one off calculations
   */
  normalizedEmployeeContributionCents(contributionOverride) {
    const contribution = contributionOverride ?? this.totalEmployeeContribution();
    let { amount } = contribution;
    if (!amount || amount < 0) {
      amount = 0;
    }
    if (isEmployeeCentsContribution(contribution)) {
      return amount;
    }
    return Big(amount).times(this.grossPaycheck()).round().toNumber();
  }
  /**
   * Normalizes the employee contribution to a rate
   * Calculator accepts cents or rate contribution amounts as inputs
   * but does all calculations using a rate
   * @param contributionOverride Used to override config value for one off calculations
   */
  normalizedEmployeeContributionRate(contributionOverride) {
    const contribution = contributionOverride && this.normalizeContributionOverride(contributionOverride) || this.totalEmployeeContributionRate();
    let { amount } = contribution;
    if (!amount || amount < 0) {
      amount = 0;
    }
    if (isEmployeeRateContribution(contribution)) {
      return Big(amount).round(this.ratePrecision).toNumber();
    }
    if (this.grossPaycheck() <= 0) {
      return 0;
    }
    return Big(amount).div(this.grossPaycheck()).round(this.ratePrecision).toNumber();
  }
  /**
   * Normalizes the employee contribution override to one contribution
   * @param contributionOverride Used to override config value for one off calculations
   */
  normalizeContributionOverride(contributionOverride) {
    if (Array.isArray(contributionOverride)) {
      if (contributionOverride.length === 0) {
        return null;
      }
      const amount = contributionOverride.reduce(
        (acc, contribution) => acc + contribution.amount,
        0
      );
      return {
        amount,
        unit: contributionOverride[0].unit
      };
    } else {
      return contributionOverride;
    }
  }
  /**
   * Returns the max employer match the participant can receive per pay period
   */
  employerAmountForOptimalContributionRate() {
    const optimalRate = this.optimalContributionRate();
    if (optimalRate) {
      return this.employerPayPeriodMatchContribution({
        amount: optimalRate,
        unit: "percent"
      });
    }
    return 0;
  }
  /**
   * Returns the optimal contribution rate for the participant to
   * receive the entire employer match
   */
  optimalContributionRate() {
    const { match } = this.employer;
    if (match.length) {
      const { limit: maxTierLimit } = this.employer.match[0];
      return maxTierLimit;
    }
    return 0;
  }
  /**
   * Returns the projected employee contribution at the end of the year
   */
  projectedYearEndContribution(...employeeContributionOverrides) {
    const uncappedProjectedYearEndContribution = Big(
      this.employeePayPeriodContribution(...employeeContributionOverrides)
    ).times(this.remainingPayPeriods()).plus(this.currentYearBalance()).round().toNumber();
    return Math.min(
      uncappedProjectedYearEndContribution,
      this.employeeContributionLimit()
    );
  }
  remainingPayPeriods() {
    return this.employee.remainingPayDates.length;
  }
  remainingPayDates() {
    return this.employee.remainingPayDates;
  }
  /**
   * Determines the participants roth adjusted gross income by deducting their
   * estimated taxes owed and their estimated annual contribution to their
   * traditional account
   */
  async rothAdjustedGrossIncome() {
    const estimatedTaxesOwed = await this.estimateTaxesOwed() ?? 0;
    const estimatedTraditionalAnnualContribution = this.employeeAnnualContribution(this.employee.traditionalContribution);
    return Math.max(
      this.employee.salary - estimatedTaxesOwed - estimatedTraditionalAnnualContribution,
      0
    );
  }
  /**
   * Combines normalized traditional and roth contributions converting to cents
   */
  totalEmployeeContribution(...employeeContributionOverrides) {
    const employeeContributions = employeeContributionOverrides.length > 0 ? employeeContributionOverrides : [
      this.employee.traditionalContribution,
      this.employee.rothContribution
    ];
    const normalizedContributions = employeeContributions.map(
      (contribution) => this.normalizedEmployeeContributionCents(contribution)
    );
    return {
      amount: sumContributions(...normalizedContributions),
      unit: "cents"
    };
  }
  /**
   * Combines normalized traditional and roth contributions converting to a rate
   */
  totalEmployeeContributionRate(...employeeContributionOverrides) {
    const employeeContributions = employeeContributionOverrides.length > 0 ? employeeContributionOverrides : [
      this.employee.traditionalContribution,
      this.employee.rothContribution
    ];
    const normalizedContributions = employeeContributions.map(
      (contribution) => this.normalizedEmployeeContributionRate(contribution)
    );
    return {
      amount: sumContributions(...normalizedContributions),
      unit: "percent"
    };
  }
  /**
   * Combined employee contribution and employer contribution rate
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  totalContributionRate(...employeeContributionOverrides) {
    return Big(
      this.totalEmployeeContributionRate(...employeeContributionOverrides).amount
    ).plus(
      this.effectiveEmployerContributionRate(...employeeContributionOverrides)
    ).round(this.ratePrecision).toNumber();
  }
  /**
   * Combined employee and employer contributions per pay period
   * Note: this number does not take into account the annual limit, it is essentially unlimited.
   * @param employeeContributionOverrides Used to override config value for one off calculations
   */
  totalPayPeriodContribution(...employeeContributionOverrides) {
    return sumContributions(
      this.employeePayPeriodContribution(...employeeContributionOverrides),
      this.employerPayPeriodContribution(...employeeContributionOverrides)
    );
  }
  /**
   * Ensures elected traditional and roth contributions satisfy tax requirements
   */
  async validateContributions({
    rothContributionOverride,
    traditionalContributionOverride
  } = {}) {
    const rothContribution = rothContributionOverride ?? this.employee.rothContribution;
    const traditionalContribution = traditionalContributionOverride ?? this.employee.traditionalContribution;
    contributionUnitShouldBeTheSame(traditionalContribution, rothContribution);
    const { unit } = traditionalContribution;
    if (unit === "cents") {
      contributionBelowLimit(
        this.totalEmployeeContribution(
          rothContribution,
          traditionalContribution
        ),
        this.employee.contributionLimit
      );
    }
    contributionDoesNotExceedCompensation(
      this.totalEmployeeContributionRate(
        rothContribution,
        traditionalContribution
      )
    );
    const maxRothContributionRate = await this.maxRothContributionRate();
    rothContributionDoesNotExceedMaxRothContribution(
      this.normalizedEmployeeContributionRate(rothContribution),
      maxRothContributionRate
    );
    return true;
  }
  /**
   * Amount contributed to 401k since start of year
   * Includes both employee and employer contributions
   */
  yearToDateContribution() {
    return this.employee.yearToDateContribution;
  }
}
const calculateContributions = (config) => {
  const calculator = new ContributionCalculator(config);
  return {
    contributionFrequency: calculator.contributionFrequency(),
    contributionLimit: calculator.employeeContributionLimit(),
    effectiveEmployerContributionRate: calculator.effectiveEmployerContributionRate(),
    effectiveMatchRate: calculator.effectiveMatchRate(),
    employee: {
      annualContribution: calculator.employeeAnnualContribution(),
      contributionRate: calculator.normalizedEmployeeContributionRate(),
      forfeitedPayPeriods: calculator.employeeForfeitedPayPeriods(),
      maxOutDate: calculator.employeeMaxOutDate(),
      payPeriodContribution: calculator.employeePayPeriodContribution()
    },
    employer: {
      annualMatchContribution: calculator.employerAnnualMatchContribution(),
      annualNonelectiveContribution: calculator.employerAnnualNonelectiveContribution(),
      matchContributionLimit: calculator.employerMatchContributionLimit(),
      missingMatchContribution: calculator.missingEmployerMatchContribution(),
      nonElectiveContributionLimit: calculator.employerNonElectiveContributionLimit(),
      optimalContributionRate: calculator.optimalContributionRate(),
      payPeriodContribution: calculator.employerPayPeriodContribution(),
      payPeriodMatchContribution: calculator.employerPayPeriodMatchContribution(),
      payPeriodNonelectiveContribution: calculator.employerPayPeriodNonelectiveContribution()
    },
    projectedYearEndContribution: calculator.projectedYearEndContribution(),
    totalPayPeriodContribution: calculator.totalPayPeriodContribution(),
    yearToDateContribution: calculator.yearToDateContribution()
  };
};
const TIER_MIN_ID = "min";
const TIER_MED_ID = "med";
const TIER_MAX_ID = "max";
const TIERS = {
  [TIER_MIN_ID]: {
    annualAumFee: 0.015,
    displayName: "Starter",
    id: TIER_MIN_ID,
    monthlyBaseRate: 39,
    monthlyParticipantFee: 4
  },
  [TIER_MED_ID]: {
    annualAumFee: 0.015,
    displayName: "Core",
    id: TIER_MED_ID,
    monthlyBaseRate: 89,
    monthlyParticipantFee: 8
  },
  [TIER_MAX_ID]: {
    annualAumFee: 0.015,
    displayName: "Enterprise",
    id: TIER_MAX_ID,
    monthlyBaseRate: 149,
    monthlyParticipantFee: 8
  }
};
const initialValues = {
  previousPlanProvider: "",
  // prevent uncontrolled inputs changing to controlled by setting "" initial values
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  // @ts-ignore
  previousPlanProviderStartDate: "",
  // Prevents form
  autoEnrollment: "",
  // @ts-ignore
  employeeCount: "",
  // @ts-ignore
  ownerCount: "",
  // @ts-ignore
  highEarners: "",
  /* eslint-enable @typescript-eslint/ban-ts-comment */
  pricingPlan: TIERS.min.id
};
const REQUIRED_FIELD = "This field is required.";
const validationSchema = create$3({
  previousPlanProvider: create$7().required(REQUIRED_FIELD),
  previousPlanProviderStartDate: create$6(),
  autoEnrollment: create$7(),
  employeeCount: create$5().required(REQUIRED_FIELD),
  ownerCount: create$5().required(REQUIRED_FIELD),
  highEarners: create$5().required(REQUIRED_FIELD),
  pricingPlan: create$6().required(REQUIRED_FIELD)
});
const formatValues = (values) => {
  const data = values ?? {};
  const previousPlanProvider = isString2(data.previousPlanProvider) ? (data == null ? void 0 : data.previousPlanProvider) === "true" : !!data.previousPlanProvider;
  const autoEnrollment = isString2(data == null ? void 0 : data.autoEnrollment) ? (data == null ? void 0 : data.autoEnrollment) === "true" : !!(data == null ? void 0 : data.autoEnrollment);
  const previousPlanProviderStartDate = previousPlanProvider && (data == null ? void 0 : data.previousPlanProviderStartDate) ? new Date(data == null ? void 0 : data.previousPlanProviderStartDate) : void 0;
  return {
    ...data,
    autoEnrollment,
    employeeCount: Number(data.employeeCount),
    hasExistingPlan: previousPlanProvider,
    highEarners: Number(data.highEarners),
    ownerCount: Number(data.ownerCount),
    previousPlanProvider,
    previousPlanProviderStartDate
  };
};
const IRS_ANNUAL_VALUES = {
  2023: {
    // HCE = Highly Compensated Employee
    HCE_THRESHOLD: 135e3
  },
  2024: {
    // HCE = Highly Compensated Employee
    HCE_THRESHOLD: 15e4
  }
};
const currentYear = (/* @__PURE__ */ new Date()).getFullYear();
const getIrsAnnualValues = (year = currentYear) => IRS_ANNUAL_VALUES[year] ?? IRS_ANNUAL_VALUES[year - 1];
const { HCE_THRESHOLD } = getIrsAnnualValues(currentYear);
const AUTO_ENROLLMENT_CREDIT_DOLLARS = 500;
const OLD_CREDIT_MAX_DOLLARS = 500;
const STARTUP_CREDIT_BASE_DOLLARS = 250;
const STARTUP_CREDIT_FIXED_MIN = 500;
const STARTUP_CREDIT_PER_NHCE_MAX = 250;
const STARTUP_CREDIT_ABSOLUTE_MAX = 5e3;
const STARTUP_CREDIT_COST_MAX_MULTIPLIER = 0.5;
const OLD_CREDIT_MULTIPLIER = 0.5;
const MAX_EMPLOYEE_AMOUNT_THRESHOLD = 100;
const MAX_EMPLOYEE_NO_CAP_AMOUNT_THRESHOLD = 50;
const SECURE_ACT_PASSED_YEAR = 2020;
const RECENT_PLAN_YEAR_THRESHOLD = 3;
const YEARS_TO_CALCULATE = 3;
const EFFECTIVE_DATE_DAYS_AWAY = 35;
const DATE_REGEXP = /^(\d{4}|[+-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)$/;
const TIME_REGEXP = /^(\d{4}|[+-]\d{6})(?:-(\d{2})(?:-(\d{2}))?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::(\d{2}))?)?)?$/;
function dateFromISO(isoDateString) {
  if (!isoDateString)
    return null;
  if (isoDateString instanceof Date)
    return isoDateString;
  const parts = isoDateString.split(/T|\s/)[0].split("-");
  return new Date(parts[0], parts[1] - 1, parts[2]);
}
const numericKeys = [1, 4, 5, 6, 7, 10, 11];
const stringToInt = (val) => typeof val === "string" ? parseInt(val, 10) : val;
function timeFromISO(date2) {
  if (!date2)
    return NaN;
  if (!/T|\s/.test(date2))
    return dateFromISO(date2);
  let timestamp, minutesOffset = 0;
  const struct = TIME_REGEXP.exec(date2);
  if (struct) {
    for (let i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    }
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;
    if (struct[8] !== "Z" && struct[9] !== void 0) {
      minutesOffset = stringToInt(struct[10]) * 60 + stringToInt(struct[11]);
      if (struct[9] === "+") {
        minutesOffset = 0 - minutesOffset;
      }
    }
    timestamp = Date.UTC(
      stringToInt(struct[1]),
      stringToInt(struct[2]),
      stringToInt(struct[3]),
      stringToInt(struct[4]),
      stringToInt(struct[5]) + minutesOffset,
      stringToInt(struct[6]),
      stringToInt(struct[7])
    );
  } else {
    timestamp = NaN;
  }
  return new Date(timestamp);
}
function normalizeDate(d) {
  if (!d)
    return d;
  if (d instanceof Date)
    return d;
  if (String(d).match(/^\d+$/)) {
    d = parseInt(d, 10);
    if (String(d).length < 13)
      d *= 1e3;
    return new Date(d);
  } else if (typeof d === "string") {
    if (TIME_REGEXP.test(d)) {
      return timeFromISO(d);
    } else if (DATE_REGEXP.test(d)) {
      return dateFromISO(d);
    }
  }
  return new Date(d);
}
function addDays(daysAway, date2 = /* @__PURE__ */ new Date()) {
  const newDate = normalizeDate(date2);
  const currentDayOfMonth = newDate.getDate();
  newDate.setDate(currentDayOfMonth + daysAway);
  return newDate;
}
function yearsToCalculate(effectiveDate) {
  const effectiveYear = effectiveDate.getFullYear();
  return Array.from(new Array(YEARS_TO_CALCULATE)).map(
    (_, i) => effectiveYear + i
  );
}
const getEffectiveDate = (date2 = /* @__PURE__ */ new Date()) => addDays(EFFECTIVE_DATE_DAYS_AWAY, date2);
function toCash(cents, stripZeros = false) {
  const dollars = toBig(cents).div(100);
  const abs_dollars = toBig(Math.abs(cents)).div(100);
  const formatted = formatMoney(dollars, stripZeros);
  const abs_formatted = formatMoney(abs_dollars, stripZeros);
  return {
    cents,
    dollars: Number(dollars.toFixed(2)),
    display_cents: formatted,
    display_dollars: formatted.split(".")[0],
    abs_display_cents: abs_formatted,
    abs_display_dollars: abs_formatted.split(".")[0]
  };
}
function toBig(number2) {
  if (!canParseBig(number2) || number2 instanceof Big) {
    return number2;
  }
  return Big(String(number2));
}
function withCommas(numericString) {
  const parts = numericString.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}
function formatMoney(value, stripZeros = true) {
  let newValue = withCommas(value.toFixed(2));
  if (stripZeros && newValue.endsWith(".00")) {
    newValue = newValue.substring(0, newValue.length - 3);
  }
  return `$${newValue}`.replace("$-", "-$");
}
function canParseBig(value) {
  try {
    Big(String(value));
    return true;
  } catch (e) {
    if (e.message === "[big.js] Invalid number")
      return false;
    throw e;
  }
}
function dollarsToCash(dollars, nullZero = false) {
  if (nullZero && !dollars || typeof dollars !== "number" || Number.isNaN(dollars)) {
    return null;
  }
  return toCash(dollars * 100, true);
}
function formatTotals(columnArray) {
  const totals = columnArray.reduce(
    (accumulator, column) => {
      var _a, _b;
      const accCost = (accumulator == null ? void 0 : accumulator.cost) ?? 0;
      const colCost = ((_a = column == null ? void 0 : column.cost) == null ? void 0 : _a.cents) ?? 0;
      return {
        cost: accCost + colCost,
        credits: accumulator.credits + (((_b = column.totalCredits) == null ? void 0 : _b.cents) ?? 0)
      };
    },
    { cost: 0, credits: 0 }
  );
  return {
    cost: toCash(totals.cost),
    credits: toCash(totals.credits)
  };
}
function formatForTable(columnArray) {
  const table = columnArray.reduce(
    (accumulator, column) => ({
      ...accumulator,
      ...Object.entries(column).reduce(
        (prevTable, [key, val]) => ({
          ...prevTable,
          [key]: (accumulator[key] || []).concat(val)
        }),
        {}
      )
    }),
    {}
  );
  if (table.totalCredits.length > 0) {
    table.totalCredits = table.totalCredits.map(
      (credits) => !credits || credits.cents <= 0 ? credits : toCash(credits.cents * -1, true)
    );
  }
  return table;
}
function mapColumnsToObject(columnArray) {
  const byYear = columnArray.reduce(
    (accumulator, column) => ({
      ...accumulator,
      [column.year]: column
    }),
    {}
  );
  return {
    ...byYear,
    table: formatForTable(columnArray)
  };
}
function calculateOldCredit({
  cost,
  eligibility,
  year
}) {
  var _a;
  if ((_a = eligibility.oldCreditYears) == null ? void 0 : _a.includes(year)) {
    return Math.min(OLD_CREDIT_MAX_DOLLARS, cost * OLD_CREDIT_MULTIPLIER);
  }
  return 0;
}
function calculateStartupCredit({
  cost,
  data,
  eligibility
}) {
  var _a;
  if (!((_a = eligibility.startupCreditYears) == null ? void 0 : _a.length))
    return 0;
  const { employeeCount, highEarners, ownerCount } = data;
  if (typeof employeeCount !== "number") {
    throw new Error(
      `Failed to process calculateStartupCredit: employeeCount value is not a number`
    );
  }
  if (typeof highEarners !== "number") {
    throw new Error(
      `Failed to process calculateStartupCredit: highEarners value is not a number`
    );
  }
  if (typeof ownerCount !== "number") {
    throw new Error(
      `Failed to process calculateStartupCredit: ownerCount value is not a number`
    );
  }
  const excludable = highEarners + ownerCount;
  const creditable = employeeCount - ownerCount;
  const top20Percent = Math.ceil(employeeCount * 0.2);
  const toExclude = Math.min(top20Percent, excludable);
  const nonOwnersToExclude = Math.max(0, toExclude - ownerCount);
  const multiplier = creditable - nonOwnersToExclude;
  const zeroEligibleAmount = multiplier === 0 ? 0 : Infinity;
  const base = multiplier * STARTUP_CREDIT_BASE_DOLLARS;
  const unlimited = Math.max(base, STARTUP_CREDIT_FIXED_MIN);
  const costMax = employeeCount > MAX_EMPLOYEE_NO_CAP_AMOUNT_THRESHOLD ? cost * STARTUP_CREDIT_COST_MAX_MULTIPLIER : cost;
  return Math.min(
    zeroEligibleAmount,
    unlimited,
    costMax,
    STARTUP_CREDIT_ABSOLUTE_MAX
  );
}
function calculateAutoEnrollmentCredit({
  eligibility,
  year
}) {
  if (eligibility.autoEnrollCreditYears.includes(year)) {
    return AUTO_ENROLLMENT_CREDIT_DOLLARS;
  }
  return 0;
}
function calculateCredits({
  carryforwardCredit,
  cost,
  data,
  eligibility,
  year
}) {
  const old = calculateOldCredit({ cost, eligibility, year });
  const startup = calculateStartupCredit({ data, eligibility, cost });
  const autoEnrollment = calculateAutoEnrollmentCredit({ eligibility, year });
  const total = old + startup + carryforwardCredit + autoEnrollment || null;
  return { autoEnrollment, carryforwardCredit, old, startup, total };
}
function getPricingPlanTier(pricingPlan) {
  return TIERS[pricingPlan];
}
function calculateCosts({
  effectiveDate,
  isCurrentYear,
  monthlyCost
}) {
  let months = 12;
  if (isCurrentYear) {
    months -= effectiveDate.getMonth();
  }
  return months * monthlyCost.dollars;
}
function calculateMonthlyCost({
  employeeCount = 0,
  pricingPlan = TIERS.min.id
}) {
  const { monthlyBaseRate, monthlyParticipantFee } = getPricingPlanTier(pricingPlan);
  const monthlyBaseRateCents = monthlyBaseRate;
  const participantFee = employeeCount * monthlyParticipantFee;
  const participantFeeCents = participantFee;
  return dollarsToCash(monthlyBaseRateCents + participantFeeCents);
}
const calculateAnnualCosts = ({
  carryforwardCredit,
  data,
  effectiveDate,
  eligibility,
  monthlyCost,
  year
}) => {
  const isCurrentYear = effectiveDate && effectiveDate.getFullYear() === year || false;
  const cost = calculateCosts({ effectiveDate, isCurrentYear, monthlyCost });
  const credits = calculateCredits({
    data,
    eligibility,
    cost,
    carryforwardCredit,
    year
  });
  const total = credits == null ? void 0 : credits.total;
  const difference = cost - total;
  return {
    autoEnrollmentCredit: dollarsToCash(credits.autoEnrollment),
    carryforwardCredit: dollarsToCash(carryforwardCredit, true),
    cost: dollarsToCash(cost),
    netCost: dollarsToCash(Math.max(0, difference)),
    nextYearCarryforward: dollarsToCash(Math.max(0, difference * -1)),
    oldCredit: dollarsToCash(credits.old),
    startupCredit: dollarsToCash(credits.startup),
    totalCredits: dollarsToCash(total),
    year
  };
};
const calculateAmounts = ({
  effectiveDate,
  eligibility,
  data
}) => {
  const years = yearsToCalculate(effectiveDate);
  const monthlyCost = calculateMonthlyCost(data);
  const calculatedColumns = years.reduce(
    (accumulator, year) => {
      var _a;
      const lastResult = accumulator && accumulator[accumulator.length - 1];
      const carryforwardCents = ((_a = lastResult == null ? void 0 : lastResult.nextYearCarryforward) == null ? void 0 : _a.cents) ?? 0;
      const yearResult = calculateAnnualCosts({
        carryforwardCredit: carryforwardCents / 100,
        data,
        effectiveDate,
        eligibility,
        monthlyCost,
        year
      });
      return [...accumulator, yearResult];
    },
    []
  );
  const result = mapColumnsToObject(calculatedColumns);
  result.totals = formatTotals(calculatedColumns);
  result.monthlyCost = monthlyCost;
  return result;
};
const PLAN_CATEGORIES = {
  new: "new",
  beforeAct: "beforeAct",
  afterAct: "afterAct",
  ineligibleEmployees: "ineligibleEmployees",
  ineligibleOther: "ineligibleOther",
  ineligibleAgeBeforeAct: "ineligibleAgeBeforeAct",
  ineligibleAgeAfterAct: "ineligibleAgeAfterAct",
  ineligibleSingleOwnerEmployee: "ineligibleSingleOwnerEmployee"
};
function planAgeFullYears({ effectiveDate, data }) {
  var _a;
  const { previousPlanProviderStartDate } = data;
  if (!previousPlanProviderStartDate)
    return 0;
  return effectiveDate.getFullYear() - ((_a = previousPlanProviderStartDate == null ? void 0 : previousPlanProviderStartDate.getFullYear) == null ? void 0 : _a.call(previousPlanProviderStartDate));
}
function planCategory({ effectiveDate, data }) {
  var _a;
  const { employeeCount = 0, ownerCount, previousPlanProviderStartDate } = data;
  if (employeeCount > MAX_EMPLOYEE_AMOUNT_THRESHOLD) {
    return PLAN_CATEGORIES.ineligibleEmployees;
  }
  if (employeeCount === 1 && ownerCount === 1) {
    return PLAN_CATEGORIES.ineligibleSingleOwnerEmployee;
  }
  if (!previousPlanProviderStartDate)
    return PLAN_CATEGORIES.new;
  const beforeAct = ((_a = previousPlanProviderStartDate == null ? void 0 : previousPlanProviderStartDate.getFullYear) == null ? void 0 : _a.call(previousPlanProviderStartDate)) < SECURE_ACT_PASSED_YEAR;
  const ageFullYears = planAgeFullYears({
    effectiveDate,
    data
  });
  if (ageFullYears <= RECENT_PLAN_YEAR_THRESHOLD - 1) {
    return beforeAct ? PLAN_CATEGORIES.beforeAct : PLAN_CATEGORIES.afterAct;
  }
  return beforeAct ? PLAN_CATEGORIES.ineligibleAgeBeforeAct : PLAN_CATEGORIES.ineligibleAgeAfterAct;
}
const DEFAULT_RESULTS = {
  oldCreditYears: [],
  startupCreditYears: [],
  autoEnrollCreditYears: []
};
function calculateNoExistingPlan({
  category,
  data,
  effectiveDate
}) {
  return {
    ...DEFAULT_RESULTS,
    startupCreditYears: primaryCreditEligibilityYears({ data, effectiveDate }),
    autoEnrollCreditYears: yearsToCalculate(effectiveDate),
    category
  };
}
function calculateIneligiblePlan(category = "") {
  return {
    ...DEFAULT_RESULTS,
    category
  };
}
function calculateAfterSecureActPlan({
  category = "",
  data,
  effectiveDate
}) {
  const base = calculateConversionPlanBase({ data, category, effectiveDate });
  base.startupCreditYears = base.primaryCreditYears;
  delete base.primaryCreditYears;
  return base;
}
function autoEnrollmentEligibilityYears({
  data,
  effectiveDate
}) {
  const { autoEnrollment, previousPlanProviderStartDate } = data;
  const years = yearsToCalculate(previousPlanProviderStartDate);
  if (autoEnrollment)
    return years;
  return years.filter((year) => year > effectiveDate.getFullYear());
}
function primaryCreditEligibilityYears({
  effectiveDate,
  data
}) {
  const { ownerCount, highEarners } = data;
  const employeeCount = data == null ? void 0 : data.employeeCount;
  const isPrimaryCreditEligible = ownerCount !== employeeCount && (employeeCount > 1 || employeeCount !== highEarners);
  if (isPrimaryCreditEligible) {
    if (!(data == null ? void 0 : data.previousPlanProviderStartDate)) {
      return yearsToCalculate(effectiveDate);
    }
    return yearsToCalculate(data == null ? void 0 : data.previousPlanProviderStartDate).filter(
      (year) => year >= effectiveDate.getFullYear()
    );
  }
  return [];
}
function calculateConversionPlanBase({
  data,
  category = "",
  effectiveDate = /* @__PURE__ */ new Date()
}) {
  const primaryCreditYears = primaryCreditEligibilityYears({
    data,
    effectiveDate
  });
  const autoEnrollCreditYears = autoEnrollmentEligibilityYears({
    data,
    effectiveDate
  });
  if ((data == null ? void 0 : data.employeeCount) !== void 0 && (data == null ? void 0 : data.employeeCount) !== null && primaryCreditYears.length === 0 && autoEnrollCreditYears.length === 0) {
    category = PLAN_CATEGORIES.ineligibleOther;
  }
  return {
    ...DEFAULT_RESULTS,
    primaryCreditYears,
    autoEnrollCreditYears,
    category
  };
}
function calculateBeforeSecureActPlan({
  category,
  data,
  effectiveDate
}) {
  const base = calculateConversionPlanBase({ data, category, effectiveDate });
  base.oldCreditYears = base.primaryCreditYears;
  delete base.primaryCreditYears;
  return base;
}
function calculateForCategory({ effectiveDate, data }) {
  const category = planCategory({ data, effectiveDate });
  switch (category) {
    case PLAN_CATEGORIES.beforeAct:
      return calculateBeforeSecureActPlan({ data, category, effectiveDate });
    case PLAN_CATEGORIES.afterAct:
      return calculateAfterSecureActPlan({ data, category, effectiveDate });
    case PLAN_CATEGORIES.ineligibleEmployees:
    case PLAN_CATEGORIES.ineligibleOther:
    case PLAN_CATEGORIES.ineligibleAgeBeforeAct:
    case PLAN_CATEGORIES.ineligibleAgeAfterAct:
    case PLAN_CATEGORIES.ineligibleSingleOwnerEmployee:
      return calculateIneligiblePlan(category);
    case PLAN_CATEGORIES.new:
    default:
      return calculateNoExistingPlan({ data, category, effectiveDate });
  }
}
const calculateEligibility = ({ effectiveDate, data }) => {
  const result = calculateForCategory({ data, effectiveDate });
  return result;
};
const calculateTaxes = (values) => {
  const data = formatValues(values);
  const effectiveDate = getEffectiveDate();
  let result;
  try {
    const eligibility = calculateEligibility({ data, effectiveDate });
    const amounts = calculateAmounts({
      data,
      effectiveDate,
      eligibility
    });
    result = { amounts, effectiveDate, eligibility };
  } catch (error) {
    console.error("error thrown", error);
  }
  return result;
};
const getIneligibleStates = (values) => {
  var _a, _b;
  const {
    autoEnrollment,
    employeeCount = 0,
    ownerCount = 0,
    previousPlanProviderStartDate
  } = formatValues(values);
  const ineligibleEmployees = !!(employeeCount && employeeCount >= MAX_EMPLOYEE_AMOUNT_THRESHOLD + 1);
  const ineligibleSingleOwnerEmployee = !!(employeeCount && ownerCount) && employeeCount === 1 && ownerCount === 1;
  const currentYear2 = (/* @__PURE__ */ new Date()).getFullYear();
  const effectiveDate = previousPlanProviderStartDate ? getEffectiveDate(previousPlanProviderStartDate) : void 0;
  const effectiveDateYear = ((_a = effectiveDate == null ? void 0 : effectiveDate.getFullYear) == null ? void 0 : _a.call(effectiveDate)) ?? currentYear2;
  const previousPlanProviderStartDateYear = ((_b = previousPlanProviderStartDate == null ? void 0 : previousPlanProviderStartDate.getFullYear) == null ? void 0 : _b.call(previousPlanProviderStartDate)) ?? 0;
  const ageFullYears = Math.abs(currentYear2 - effectiveDateYear);
  const isCompanyCreatedBeforeAct = previousPlanProviderStartDateYear > 0 && previousPlanProviderStartDateYear < SECURE_ACT_PASSED_YEAR;
  const isCompanyAgeIneligible = ageFullYears > RECENT_PLAN_YEAR_THRESHOLD - 1;
  const ineligibleSecureActYearBefore = isCompanyAgeIneligible && isCompanyCreatedBeforeAct;
  const ineligibleSecureActYearAfter = isCompanyAgeIneligible && !isCompanyCreatedBeforeAct;
  const higherThanEffectiveDate = effectiveDate ? currentYear2 > effectiveDate.getFullYear() : false;
  const employeeAndOwnersEqual = employeeCount > 0 && ownerCount > 0 && employeeCount === ownerCount;
  const ineligibleOther = higherThanEffectiveDate && employeeAndOwnersEqual && !autoEnrollment;
  const ineligible = ineligibleOther || ineligibleSecureActYearAfter || ineligibleSecureActYearBefore || ineligibleSingleOwnerEmployee;
  return {
    ineligible,
    ineligibleEmployees,
    ineligibleOther,
    ineligibleSecureActYearAfter,
    ineligibleSecureActYearBefore,
    ineligibleSingleOwnerEmployee
  };
};
const Warning = ({
  ineligibleEmployees = false,
  ineligibleOther = false,
  ineligibleSecureActYearAfter = false,
  ineligibleSecureActYearBefore = false,
  ineligibleSingleOwnerEmployee = false,
  onDismiss
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    InlineCallout,
    {
      onDismiss,
      showDismiss: true,
      sx: { mt: 1 },
      title: "Your business may not qualify for tax credits",
      variant: "info",
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Tooltip.Source,
            {
              "data-test-id": "warning-TooltipSource",
              trigger: Triggers.hover,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Span,
                {
                  "aria-labelledby": "beforeSecureAct-TooltipSource",
                  sx: { borderBottom: "dashed 1px", cursor: "pointer" },
                  children: "The Small Employer Start-Up Costs tax credit"
                }
              )
            }
          ),
          " ",
          /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { hideTail: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Paragraph,
            {
              "aria-live": "polite",
              color: TextColors.white,
              role: "tooltip",
              sx: { marginBottom: 0, textAlign: "left" },
              children: "Covers eligible startup costs required to set up the plan, administer it, and educate employees"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Span, { children: [
          ineligibleSecureActYearBefore ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            "only applies to small businesses starting a new 401(k) in",
            " ",
            SECURE_ACT_PASSED_YEAR,
            " or later. However, you may still benefit from tax deductions related to plan expenses such as employer contributions."
          ] }) : null,
          ineligibleSecureActYearAfter ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "only applies to a 401(k) plan within its first three years. However, you may still benefit from tax deductions related to plan expenses such as employer contributions." }) : null,
          !ineligibleOther && (ineligibleEmployees || ineligibleSingleOwnerEmployee) ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            "only applies to businesses with ",
            MAX_EMPLOYEE_AMOUNT_THRESHOLD,
            " or fewer employees. However, you may still benefit from tax deductions related to plan expenses such as employer contributions."
          ] }) : null,
          ineligibleOther ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            "only applies to businesses with at least one non-highly compensated employee. The new Auto-Enrollment tax credit only applies to new 401(k) plans adopted in ",
            SECURE_ACT_PASSED_YEAR,
            " with an Automatic Contribution Arrangement, or to a pre-existing 401(k) plan that adds such a feature to its plan after ",
            SECURE_ACT_PASSED_YEAR - 1,
            ". If you don’t qualify for either credit, you may still benefit from tax deductions."
          ] }) : null
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            external: true,
            href: "/blog/4-reasons-why-small-businesses-should-start-a-401-k/",
            sx: { mt: 1, backgroundColor: "#fff" },
            variant: ButtonVariant.secondary,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { children: "Learn more about 401(k) tax savings" })
          }
        )
      ]
    }
  );
};
const EmployeeOwnerCount = ({ trackEvent = () => {
} }) => {
  const { setFieldValue, values } = useGuiForm();
  const onChange = (event) => {
    const { name, value } = event.target;
    trackEvent("fieldChanged", {
      [name]: value
    });
  };
  const {
    ineligibleEmployees,
    ineligibleSingleOwnerEmployee,
    ineligibleOther
  } = getIneligibleStates(values);
  const onDismiss = (value) => {
    if (typeof value === "string") {
      return setFieldValue == null ? void 0 : setFieldValue(value, "");
    }
    value.forEach((field) => {
      setFieldValue == null ? void 0 : setFieldValue(field, "");
    });
  };
  const onWheel = () => {
    document.activeElement.blur();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Label,
        {
          htmlFor: "employeeCount",
          sx: { display: "inline", fontWeight: "700", mb: 0.5 },
          children: [
            "How many ",
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Tooltip.Source,
                {
                  "data-test-id": "employeeCount-TooltipSource",
                  trigger: Triggers.hover,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Box,
                    {
                      "aria-labelledby": "employeeCount-TooltipSource",
                      role: "tooltip",
                      sx: {
                        borderBottom: "dashed 1px",
                        cursor: "pointer",
                        display: "inline"
                      },
                      children: "employees"
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Paragraph,
                {
                  "aria-live": "polite",
                  color: TextColors.white,
                  role: "tooltip",
                  sx: { marginBottom: 0, textAlign: "left" },
                  children: [
                    "Anyone who earns over $5,000 in income reported on a W-2 by your company, including interns, part-time employees, and full-time employees. Also include owners earning self-employed income. If you have more than ",
                    MAX_EMPLOYEE_AMOUNT_THRESHOLD,
                    " employees you are not eligible for the credits."
                  ]
                }
              ) })
            ] }),
            " (including owners)?"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Input,
        {
          id: "employeeCount",
          min: "1",
          name: "employeeCount",
          onChange,
          onWheel,
          placeholder: "Employees",
          type: InputTypes.number
        }
      ),
      ineligibleEmployees ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Warning,
        {
          ineligibleEmployees: true,
          onDismiss: () => onDismiss("employeeCount")
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Label,
        {
          htmlFor: "ownerCount",
          sx: { display: "inline", fontWeight: "700", mb: 0.5 },
          children: [
            "How many ",
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Tooltip.Source,
                {
                  "data-test-id": "ownerCount-TooltipSource",
                  trigger: Triggers.hover,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Box,
                    {
                      "aria-labelledby": "ownerCount-TooltipSource",
                      role: "tooltip",
                      sx: {
                        borderBottom: "dashed 1px",
                        cursor: "pointer",
                        display: "inline"
                      },
                      children: "owners"
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Paragraph,
                {
                  "aria-live": "polite",
                  color: TextColors.white,
                  role: "tooltip",
                  sx: { marginBottom: 0, textAlign: "left" },
                  children: "Anyone who owns more than 5% of the business and is employed with the company and employees who are a close relation (spouse, grand-parent, parent, child) of an owner."
                }
              ) })
            ] }),
            " of the company?"
          ]
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Input,
        {
          id: "ownerCount",
          min: "0",
          name: "ownerCount",
          onChange,
          onWheel,
          placeholder: "Owners",
          type: InputTypes.number
        }
      ),
      ineligibleSingleOwnerEmployee ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Warning,
        {
          ineligibleEmployees: true,
          onDismiss: () => onDismiss("ownerCount")
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { htmlFor: "highEarners", sx: { fontWeight: "700", mb: 0.5 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
        "How many employees earned more than $",
        HCE_THRESHOLD == null ? void 0 : HCE_THRESHOLD.toLocaleString(),
        " last year? (",
        /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { fontWeight: 600, textDecoration: "underline" }, children: "not" }),
        " ",
        "including owners)"
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Input,
        {
          id: "highEarners",
          min: "0",
          name: "highEarners",
          onChange,
          onWheel,
          placeholder: "High earners",
          type: InputTypes.number
        }
      ),
      ineligibleOther ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Warning,
        {
          ineligibleOther: true,
          onDismiss: () => onDismiss(["ownerCount", "highEarners"])
        }
      ) : null
    ] })
  ] });
};
const DisclosureStatement = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Box,
  {
    sx: {
      ul: {
        m: 0,
        p: 0,
        paddingInlineStart: 1,
        // LI elements except first one have margin-top=0.5rem
        li: { mt: 0.5 },
        "li:first-of-type": { mt: 0 }
      }
    },
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", variant: TitleSizes.Title24, children: "Assumptions and disclosures" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "This illustration is for informational purposes only. It does not take into account your specific circumstances. It is not intended to provide tax, legal, or accounting advice. You should consult your own tax, legal, and accounting advisors before determining any tax filing position. The analyses and calculations are based on certain assumptions described below. The analyses and calculations are also based on Guideline’s interpretation of prevailing law, which is subject to change at any time. No warranty or representation, express or implied, is made by Guideline, nor does Guideline accept any liability with respect to the analyses, calculations, and data set forth herein. Furthermore, Guideline’s fees may be subject to modification in the future." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { mt: 1 }, variant: TitleSizes.Title18, children: "For the purposes of this calculator we assume:" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "If you have an existing plan, it has never included an Eligible Automatic Contribution Arrangement (EACA) or Qualified Automatic Contribution Arrangement (QACA) provision before." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "You don’t have any administrative costs associated with your existing plan prior to converting it to Guideline. Since other providers have varying administrative costs, we can’t accurately predict this for you or factor it in." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "The number of employees, owners, and highly compensated employees you provided will remain fixed during the first three years of your plan." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "You will remain in the same pricing plan with Guideline during the first three years of your plan." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "All employees are eligible for your 401(k) plan." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "Highly Compensated Employees (HCE) are those that:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
              "Earned more than $",
              HCE_THRESHOLD.toLocaleString(),
              " last year",
              " ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "and" }),
              " were in the top 20% of all employees by compensation; ",
              /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: "or" })
            ] }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "Own more than 5% of the company sponsoring the 401(k) plan" }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "Non-Highly Compensated Employees (NHCE) are those that are not HCEs." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "You did not maintain a prior plan anytime during the previous three tax years that covered substantially the same group of employees." }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { mt: 1 }, variant: TitleSizes.Title18, children: "Startup credit" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
          "If your plan does not allow any non-highly compensated employees to participate, you will ",
          /* @__PURE__ */ jsxRuntimeExports.jsx("u", { children: "not" }),
          " qualify for the startup credit."
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
          "The startup credit is calculated based on the number of NHCE in the plan and covers the costs required to set up and administer the plan as well as to educate employees about the plan. If you have more than",
          " ",
          MAX_EMPLOYEE_AMOUNT_THRESHOLD,
          " employees you will not be eligible for the startup credit."
        ] }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
            "The possible annual credit amount is the greater of (1) $",
            STARTUP_CREDIT_FIXED_MIN,
            ", or (2) $",
            STARTUP_CREDIT_PER_NHCE_MAX,
            " per eligible NHCE, limited to $",
            STARTUP_CREDIT_ABSOLUTE_MAX.toLocaleString(),
            " per year."
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
              "If your business has ",
              MAX_EMPLOYEE_NO_CAP_AMOUNT_THRESHOLD + 1,
              " -",
              " ",
              MAX_EMPLOYEE_AMOUNT_THRESHOLD,
              " employees, the credit cannot exceed 50% of the eligible startup costs paid or incurred in a tax year."
            ] }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
              "If your business has ",
              MAX_EMPLOYEE_NO_CAP_AMOUNT_THRESHOLD,
              " or fewer employees, the credit cannot exceed 100% of the eligible startup costs paid or incurred in a tax year."
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "If the maximum allowable tax credit for any year exceeds the cost of administering the plan for that year, the excess credit may be rolled forward to a future year." }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { mt: 1 }, variant: TitleSizes.Title18, children: "Auto-enrollment credit" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("li", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "You may qualify for the auto-enrollment credit if" }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "you have added an Eligible Automatic Enrollment Arrangement (EACA) or Qualified Automatic Enrollment Arrangement (QACA) provision to your new or existing plan" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { variant: ParagraphSizes.Paragraph14, children: [
              "you have ",
              MAX_EMPLOYEE_AMOUNT_THRESHOLD,
              " or fewer employees"
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "You may qualify for the auto-enrollment credit even if your plan only allows participation by HCEs." }) })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "div", sx: { mt: 1 }, variant: TitleSizes.Title18, children: "Estimated cost after tax credits" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("ul", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "This is an illustration of how your estimated tax credits may help offset your estimated overall costs to open and maintain your 401(k) plan with Guideline for your first three years. Any tax credits your company is eligible for cannot be directly applied to your Guideline invoice." }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("li", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { variant: ParagraphSizes.Paragraph14, children: "The estimated employer cost of your Guideline 401(k) is an illustration based on the monthly base fee for the Guideline pricing plan you have selected and the monthly $4-8 active participant fee for the number of employees inputted." }) })
      ] })
    ]
  }
);
const FooterActions = ({ trackEvent = () => {
} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const onDismiss = () => setIsOpen(false);
  const onClick = () => {
    trackEvent("buttonClicked", {
      tax_calculator_assumptions_disclosures: "open"
    });
    setIsOpen(true);
  };
  const { values, isValid } = useGuiForm();
  const { ineligible } = getIneligibleStates(values);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      justifyContent: "space-between",
      sx: {
        alignItems: buildResponsiveValues({
          mdDown: "flex-start",
          mdUp: "center"
        }),
        flexDirection: buildResponsiveValues({
          mdDown: "column",
          mdUp: "row"
        })
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Button,
          {
            onClick,
            sx: {
              mb: "1rem",
              color: TextColors.tertiary,
              textDecoration: "underline"
            },
            variant: ButtonVariant.unstyled,
            children: "Assumptions & disclosures"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Modal,
          {
            footerActions: /* @__PURE__ */ jsxRuntimeExports.jsx("i", {}),
            informational: true,
            isOpen,
            onDismiss,
            title: "",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(DisclosureStatement, {})
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Submit,
          {
            disabled: !isValid || ineligible,
            label: "Estimate your costs",
            sx: { fontWeight: "700" }
          }
        )
      ]
    }
  );
};
const today = (/* @__PURE__ */ new Date()).toISOString().split("T")[0];
const PreviousPlanProvider = ({ trackEvent = () => {
} }) => {
  const { setFieldValue, values } = useGuiForm();
  const previousPlanProvider = values == null ? void 0 : values.previousPlanProvider;
  const previousPlanProviderStartDate = values == null ? void 0 : values.previousPlanProviderStartDate;
  const hasPreviousPlanProvider = previousPlanProvider === "true";
  const {
    ineligibleSecureActYearAfter = false,
    ineligibleSecureActYearBefore = false
  } = previousPlanProviderStartDate ? getIneligibleStates(values) : {};
  const onChange = (event) => {
    const { name, value } = event.target;
    trackEvent("fieldChanged", {
      [name]: value
    });
  };
  const onDismiss = () => {
    setFieldValue("previousPlanProviderStartDate", "");
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 2, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Label,
        {
          htmlFor: "previousPlanProvider",
          sx: { fontWeight: "700", mb: 0.5 },
          children: "Does your company currently offer a 401(k)?"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Radio.Group, { name: "previousPlanProvider", onChange, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio.Option,
          {
            id: "previousPlanProviderYes",
            label: "Yes",
            name: "previousPlanProviderYes",
            value: true
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Radio.Option,
          {
            id: "previousPlanProviderNo",
            label: "No",
            name: "previousPlanProviderNo",
            value: false
          }
        )
      ] })
    ] }),
    hasPreviousPlanProvider ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Label,
          {
            htmlFor: "previousPlanProviderStartDate",
            sx: { fontWeight: "700", mb: 0.5 },
            children: "When did the plan start?"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Input,
          {
            "data-test-id": "previousPlanProviderStartDate",
            max: today,
            name: "previousPlanProviderStartDate",
            onChange,
            sx: { minWidth: "10rem" },
            type: InputTypes.date
          }
        ),
        previousPlanProviderStartDate && (ineligibleSecureActYearAfter || ineligibleSecureActYearBefore) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Warning,
          {
            ineligibleSecureActYearAfter,
            ineligibleSecureActYearBefore,
            onDismiss
          }
        ) : null
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Label,
          {
            htmlFor: "autoEnrollment",
            sx: { display: "inline", fontWeight: "700", mb: 0.5 },
            children: [
              "Does your current plan have ",
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Tooltip.Source,
                  {
                    "data-test-id": "autoEnrollment-TooltipSource",
                    trigger: Triggers.hover,
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Box,
                      {
                        "aria-labelledby": "autoEnrollment-TooltipSource",
                        role: "tooltip",
                        sx: {
                          borderBottom: "dashed 1px",
                          cursor: "pointer",
                          display: "inline"
                        },
                        children: "automatic enrollment"
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Paragraph,
                  {
                    "aria-live": "polite",
                    color: TextColors.white,
                    role: "tooltip",
                    sx: { marginBottom: 0, textAlign: "left" },
                    children: "Eligible employees are enrolled at a default contribution rate unless they opt out of participating."
                  }
                ) })
              ] }),
              "?"
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Radio.Group, { name: "autoEnrollment", onChange, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Radio.Option,
            {
              id: "autoEnrollmentYes",
              label: "Yes",
              name: "autoEnrollmentYes",
              value: true
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Radio.Option,
            {
              id: "autoEnrollmentNo",
              label: "No",
              name: "autoEnrollmentNo",
              value: false
            }
          )
        ] })
      ] })
    ] }) : null
  ] });
};
const Legend = ({ year }) => {
  const years = year.slice(0, 3);
  const justifyContentCells = buildResponsiveValues({
    smDown: "flex-end",
    smUp: "center"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    HStack,
    {
      justifyContent: "flex-end",
      sx: { mb: 1, minWidth: "11.5rem", width: "50%" },
      children: years.map((year2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Flex,
        {
          justifyContent: justifyContentCells,
          sx: { width: "calc(5rem - .15rem)" },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(Tag, { text: `${year2}`, variant: TagVariant.indeterminate })
        },
        year2
      ))
    }
  );
};
const isNull = (credit) => credit === null;
const TableRow = ({
  cellSx = {},
  collapsibleControl = false,
  credits = [],
  inset = false,
  label,
  tooltip = "",
  trackEvent = () => {
  }
}) => {
  const { collapsed } = useCollapsible();
  if (!(credits == null ? void 0 : credits.length) || (credits == null ? void 0 : credits.every(isNull))) {
    return null;
  }
  const icon = collapsed ? "chevronRight" : "chevronUp";
  const sx = {
    borderBottom: inset ? "" : "solid 1px",
    borderColor: "border.subdued",
    justifyContent: "space-between",
    mb: 0.5,
    mt: 0.5,
    pl: inset ? buildResponsiveValues({
      smDown: 1,
      smUp: 6
    }) : buildResponsiveValues({
      smDown: 0.5,
      smUp: 1
    }),
    pb: 1,
    width: "100%"
  };
  const onHover = debounce(() => {
    if (!label) {
      return;
    }
    trackEvent("fieldHover", {
      tax_calculator: label
    });
  }, 1e3);
  const onCollapsible = () => {
    const value = collapsed ? "open" : "closed";
    trackEvent("buttonClicked", {
      tax_calculator_collapsible_annual_tax: value
    });
  };
  const span = /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Span,
    {
      "aria-labelledby": `${label}-TooltipSource`,
      sx: {
        alignItems: "center",
        borderBottom: "dashed 1px",
        cursor: "pointer",
        display: "inline-flex",
        maxWidth: collapsibleControl ? buildResponsiveValues({
          smDown: "calc(100% - 1rem)",
          smUp: "100%"
        }) : "calc(100 - 1rem)"
      },
      children: [
        label,
        collapsibleControl ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: icon, size: IconSizes.Icon12, sx: { ml: 0.5 } }) : null
      ]
    }
  );
  const labelComponent = tooltip ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { sx: { ml: inset ? "5rem" : "" }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tooltip.Source,
      {
        "data-test-id": `${label}-TooltipSource`,
        onAction: async () => onHover(),
        trigger: Triggers.hover,
        children: span
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paragraph,
      {
        "aria-live": "polite",
        color: TextColors.white,
        role: "tooltip",
        sx: { marginBottom: 0, textAlign: "left" },
        children: tooltip
      }
    ) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { children: label });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { sx, children: [
    collapsibleControl ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Collapsible.Control,
      {
        action: CollapsibleAction.toggle,
        onAction: async () => onCollapsible(),
        sx: {
          background: "none",
          border: "none",
          color: "text.primary",
          display: "flex",
          padding: 0,
          maxWidth: "calc(50% - 1rem)",
          textAlign: "left",
          "&:hover": {
            background: "none"
          },
          "& > div": {
            width: "100%",
            "& > span": {
              width: "100%"
            }
          }
        },
        children: labelComponent
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { children: labelComponent }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { sx: { maxWidth: "50%", minWidth: "11.5rem" }, children: credits.map((credit, i) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Flex,
        {
          alignItems: "center",
          justifyContent: "center",
          sx: {
            width: "5rem",
            fontFamily: "body",
            color: inset ? "text.secondary" : "",
            ...cellSx
          },
          children: credit == null ? void 0 : credit.display_dollars
        },
        `startup-credit-${credit == null ? void 0 : credit.display_dollars}-${i}`
      );
    }) })
  ] });
};
const autoEnrollmentTooltip = `This will only be available if your plan does not already include an EACA or QACA provision. The $${AUTO_ENROLLMENT_CREDIT_DOLLARS} small employer automatic enrollment credit is available for the first ${RECENT_PLAN_YEAR_THRESHOLD} years that a plan includes an EACA or QACA provision.`;
const carryforwardTooltip = "If you can’t apply the full credit for a given year, you may roll over the excess credit to following years. ";
const startupTooltip = `The maximum annual credit limit is the greater of $${STARTUP_CREDIT_FIXED_MIN}, or $${STARTUP_CREDIT_PER_NHCE_MAX} per eligible non-highly compensated employee, up to $${STARTUP_CREDIT_ABSOLUTE_MAX}. For businesses with ${MAX_EMPLOYEE_NO_CAP_AMOUNT_THRESHOLD + 1}-${MAX_EMPLOYEE_AMOUNT_THRESHOLD} employees, the credit cannot exceed 50% of eligible startup costs paid or incurred in a tax year.`;
const totalCreditsTooltip = "A tax credit can offset the amount of taxes you owe.";
const getResultsTooltips = ({
  effectiveDate,
  pricingPlan
}) => {
  const { displayName, id, monthlyBaseRate, monthlyParticipantFee } = getPricingPlanTier(pricingPlan);
  const proratedDate = effectiveDate == null ? void 0 : effectiveDate.toLocaleString("default", {
    month: "long",
    year: "numeric"
  });
  const starterPlan = id === TIERS[TIER_MIN_ID].id ? displayName : "";
  const enterpriseNote = id === TIERS[TIER_MAX_ID].id ? "Note that this is the most common pricing structure for Enterprise plans. Your actual costs may vary depending on the structure you choose." : "";
  const costTooltip = `
    You’ll be billed $${monthlyBaseRate} plus $${monthlyParticipantFee}/participant on a monthly basis. 
    Your ${starterPlan} 401(k) costs and credits for the first year are pro-rated. 
    This is based on starting your new plan in ${proratedDate}. ${enterpriseNote}`;
  return {
    autoEnrollmentTooltip,
    carryforwardTooltip,
    costTooltip,
    startupTooltip,
    totalCreditsTooltip
  };
};
const ResultsTable = ({
  amounts: initialAmounts,
  formHidden,
  cta = null,
  setFormHidden,
  trackEvent = () => {
  }
}) => {
  var _a;
  const { values } = useGuiForm();
  const { effectiveDate, pricingPlan } = values;
  const [amounts, setAmounts] = useState(initialAmounts);
  const [tooltips, setTooltips] = useState(
    getResultsTooltips({ effectiveDate, pricingPlan })
  );
  const prevAmounts = (_a = calculateTaxes(values)) == null ? void 0 : _a.amounts;
  const showForm = () => {
    setFormHidden(false);
  };
  useEffect(() => {
    if (!isEqual(prevAmounts, amounts) && prevAmounts) {
      setAmounts(prevAmounts);
      setTooltips(
        getResultsTooltips({
          effectiveDate,
          pricingPlan
        })
      );
    }
  }, [isEqual(prevAmounts, amounts)]);
  const { monthlyCost, table } = amounts;
  const {
    autoEnrollmentCredit,
    carryforwardCredit,
    cost,
    netCost = [],
    startupCredit,
    totalCredits,
    year
  } = table;
  const {
    autoEnrollmentTooltip: autoEnrollmentTooltip2,
    carryforwardTooltip: carryforwardTooltip2,
    costTooltip,
    startupTooltip: startupTooltip2,
    totalCreditsTooltip: totalCreditsTooltip2
  } = tooltips;
  const onClick = () => {
    var _a2;
    (_a2 = cta == null ? void 0 : cta.onClick) == null ? void 0 : _a2.call(cta);
    trackEvent("linkClicked", {
      tax_calculator: "get_started_link"
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible, { initiallyCollapsed: false, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { justifyContent: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Legend, { year }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { justifyContent: "space-between", sx: { width: "100%" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TableRow,
      {
        cellSx: { fontWeight: "600" },
        credits: cost,
        label: `Cost of your Guideline 401(k) @ ${monthlyCost.display_dollars}/mo`,
        tooltip: costTooltip,
        trackEvent
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { justifyContent: "space-between", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      TableRow,
      {
        cellSx: { color: "text.success", fontWeight: "600", mr: "1px" },
        collapsibleControl: true,
        credits: totalCredits,
        label: "Annual tax credit",
        tooltip: totalCreditsTooltip2,
        trackEvent
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Collapsible.Content, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TableRow,
        {
          credits: startupCredit,
          inset: true,
          label: "Startup credit",
          tooltip: startupTooltip2,
          trackEvent
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TableRow,
        {
          credits: autoEnrollmentCredit,
          inset: true,
          label: "Auto-enrollment credit",
          tooltip: autoEnrollmentTooltip2,
          trackEvent
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        TableRow,
        {
          credits: carryforwardCredit,
          inset: true,
          label: "Credit carryforward",
          tooltip: carryforwardTooltip2,
          trackEvent
        }
      )
    ] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HStack,
      {
        justifyContent: "space-between",
        sx: {
          backgroundColor: "surface.neutral",
          borderRadius: "4px",
          ">div": {
            borderColor: "transparent",
            pb: 0.5,
            pt: 0.5
          }
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          TableRow,
          {
            credits: netCost,
            label: "Yearly employer cost after tax credits"
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { sx: { mt: 1 }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "h4", sx: { my: 1 }, variant: TitleSizes.Title16, children: "Additional tax benefits" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { children: [
        "You may also benefit from tax deductions on employer contributions, potentially up to $1,000 per employee, for the first 2-5 years of the plan. You can find more information about the various tax credits ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            external: true,
            href: "https://success.guideline.com/helpcenter/s/article/tax-credits-for-small-businesses-offering-401k-accounts",
            sx: { display: "inline", textDecoration: "underline" },
            variant: ButtonVariant.unstyled,
            children: "here"
          }
        ),
        "."
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "h4", sx: { my: 0.75 }, variant: TitleSizes.Title16, children: "Let’s get started" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph, { children: "Tell us more about your company so we can set you up with the 401(k) plan that’s right for you." }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justifyContent: "space-between", sx: { mt: 1 }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: "auto", children: formHidden && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: showForm, variant: ButtonVariant.secondary, children: "Change assumptions" }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: "auto", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Link,
          {
            external: (cta == null ? void 0 : cta.external) ?? false,
            href: (cta == null ? void 0 : cta.href) ?? "/pipeline/basic",
            onClick,
            variant: ButtonVariant.primary,
            children: (cta == null ? void 0 : cta.text) ?? "Get started"
          }
        ) })
      ] })
    ] })
  ] }) });
};
const tierOptions = [
  {
    option: TIERS.min.displayName,
    value: TIERS.min.id
  },
  {
    option: TIERS.med.displayName,
    value: TIERS.med.id
  },
  {
    option: TIERS.max.displayName,
    value: TIERS.max.id
  }
];
const SelectPricingPlan = ({ trackEvent = () => {
} }) => {
  const { setFieldValue, values } = useGuiForm();
  const { previousPlanProvider } = values;
  const hasPreviousPlanProvider = previousPlanProvider === "true";
  const disabled = hasPreviousPlanProvider;
  useEffect(() => {
    const newValue = hasPreviousPlanProvider ? TIERS.max.id : TIERS.min.id;
    setFieldValue == null ? void 0 : setFieldValue("pricingPlan", newValue);
  }, [hasPreviousPlanProvider, setFieldValue]);
  const onChange = (event) => {
    const { name, innerText } = event.target;
    trackEvent("fieldChanged", {
      [name]: innerText.toLowerCase()
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Label, { htmlFor: "pricingPlan", sx: { fontWeight: "700", mb: 0.5 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tooltip.Source,
          {
            "data-test-id": "pricingPlan-TooltipSource",
            trigger: Triggers.hover,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                "aria-labelledby": "pricingPlan-TooltipSource",
                role: "tooltip",
                sx: { borderBottom: "dashed 1px", cursor: "pointer" },
                children: "Guideline pricing plan"
              }
            )
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph,
          {
            "aria-live": "polite",
            color: TextColors.white,
            role: "tooltip",
            sx: { marginBottom: 0, textAlign: "left" },
            children: "You can find the cost associated with each level under the “Assumptions & Disclosures” link."
          }
        ) })
      ] }) }),
      disabled ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Paragraph, { color: TextColors.tertiary, sx: { fontSize: "14px" }, children: [
        "Transferring an existing 401(k) to Guideline requires an",
        " ",
        TIERS.max.displayName,
        " plan for the first year."
      ] }) : null
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        defaultValue: TIERS.min.id,
        disabled: hasPreviousPlanProvider,
        name: "pricingPlan",
        onChange,
        options: tierOptions
      }
    )
  ] });
};
const TaxCalculatorForm = ({
  cta,
  hideForm = false,
  trackEvent = () => {
  },
  ...rest
}) => {
  const [results, setResults] = useState(
    void 0
  );
  const [formHidden, setFormHidden] = useState(hideForm);
  const isIneligible = getIneligibleStates(results).ineligible;
  const onSubmit = (values) => {
    if (isIneligible) {
      return;
    }
    const formattedResults = calculateTaxes(values);
    setResults(formattedResults);
    trackEvent("formSubmitted", {
      tax_calculator: "estimate_your_costs"
    });
  };
  useEffect(() => {
    if (getIneligibleStates(rest).ineligible) {
      return;
    }
    if (!Object.keys(rest).length) {
      return;
    }
    setResults(calculateTaxes(rest));
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Form$1,
    {
      enableReinitialize: true,
      initialValues: {
        ...initialValues,
        ...rest
      },
      name: "TaxCalculator",
      onSubmit,
      validateOnChange: true,
      validationSchema,
      children: ({ isValid }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          sx: {
            padding: buildResponsiveValues({
              smDown: 1,
              mdUp: 2.5
            })
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 3, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Box,
              {
                sx: {
                  display: !formHidden || formHidden && !results ? "block" : "none"
                },
                children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 2, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(PreviousPlanProvider, { trackEvent }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(EmployeeOwnerCount, { trackEvent }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(SelectPricingPlan, { trackEvent }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(FooterActions, { trackEvent })
                ] })
              }
            ),
            results && isValid && !isIneligible && /* @__PURE__ */ jsxRuntimeExports.jsx(
              ResultsTable,
              {
                ...results,
                cta,
                formHidden,
                setFormHidden,
                trackEvent
              }
            )
          ] })
        }
      )
    }
  );
};
const TaxCalculator = ({
  cta,
  hideForm = false,
  trackEvent = () => {
  },
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(AppProviders, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0px 1px 2px rgba(25, 24, 23, 0.16)"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        TaxCalculatorForm,
        {
          cta,
          hideForm,
          trackEvent,
          ...restOfProps
        }
      )
    }
  ) });
};
export {
  CalSaversCalculator,
  ContributionCalculator,
  types as ContributionCalculatorTypes,
  TaxCalculator,
  TaxCalculatorForm,
  calculateContributions
};
//# sourceMappingURL=index.js.map
